/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum LocationVarKey { 
    AboutStorageCompanyURL = "AboutStorageCompanyURL",
    AccessAfterHour1 = "AccessAfterHour1",
    AccessAfterHour2 = "AccessAfterHour2",
    AccessAfterHour2Enabled = "AccessAfterHour2Enabled",
    AccessGateCode1 = "AccessGateCode1",
    AccessGateCode2 = "AccessGateCode2",
    AccessGateCode3 = "AccessGateCode3",
    AccessGateCode3Enabled = "AccessGateCode3Enabled",
    AccessHours = "AccessHours",
    AccessUnitNumber1 = "AccessUnitNumber1",
    AccessUnitNumber2 = "AccessUnitNumber2",
    AccessUnitNumber3 = "AccessUnitNumber3",
    AccessUnitNumber3Enabled = "AccessUnitNumber3Enabled",
    AccountAutoPay1 = "AccountAutoPay1",
    AccountAutoPay2 = "AccountAutoPay2",
    AccountAutoPay2Enabled = "AccountAutoPay2Enabled",
    AccountBalance1 = "AccountBalance1",
    AccountBalance2 = "AccountBalance2",
    AccountBalance3 = "AccountBalance3",
    AccountBalance3Enabled = "AccountBalance3Enabled",
    AccountBillingDispute1 = "AccountBillingDispute1",
    AccountBillingDispute2 = "AccountBillingDispute2",
    AccountBillingDispute2Enabled = "AccountBillingDispute2Enabled",
    AccountCancelService1 = "AccountCancelService1",
    AccountCancelService2 = "AccountCancelService2",
    AccountCancelService2Enabled = "AccountCancelService2Enabled",
    AccountCreateLogin1 = "AccountCreateLogin1",
    AccountCreateLogin2 = "AccountCreateLogin2",
    AccountCreateLogin2Enabled = "AccountCreateLogin2Enabled",
    AccountDebtCredit1 = "AccountDebtCredit1",
    AccountDebtCredit2 = "AccountDebtCredit2",
    AccountDebtCredit2Enabled = "AccountDebtCredit2Enabled",
    AccountForgotUsername1 = "AccountForgotUsername1",
    AccountForgotUsername2 = "AccountForgotUsername2",
    AccountForgotUsername2Enabled = "AccountForgotUsername2Enabled",
    AccountGetLease1 = "AccountGetLease1",
    AccountGetLease2 = "AccountGetLease2",
    AccountGetLease2Enabled = "AccountGetLease2Enabled",
    AccountGracePeriod1 = "AccountGracePeriod1",
    AccountGracePeriod2 = "AccountGracePeriod2",
    AccountGracePeriod2Enabled = "AccountGracePeriod2Enabled",
    AccountInactiveOptOut = "AccountInactiveOptOut",
    AccountLoginURL = "AccountLoginURL",
    AccountManageInsurance1 = "AccountManageInsurance1",
    AccountManageInsurance2 = "AccountManageInsurance2",
    AccountManageInsurance2Enabled = "AccountManageInsurance2Enabled",
    AccountMultipleAccounts1 = "AccountMultipleAccounts1",
    AccountMultipleAccounts2 = "AccountMultipleAccounts2",
    AccountMultipleAccounts2Enabled = "AccountMultipleAccounts2Enabled",
    AccountNumber1 = "AccountNumber1",
    AccountNumber2 = "AccountNumber2",
    AccountNumber2Enabled = "AccountNumber2Enabled",
    AccountPartialPayment1 = "AccountPartialPayment1",
    AccountPartialPayment2 = "AccountPartialPayment2",
    AccountPartialPayment2Enabled = "AccountPartialPayment2Enabled",
    AccountPastDue1 = "AccountPastDue1",
    AccountPastDue2 = "AccountPastDue2",
    AccountPastDue2Enabled = "AccountPastDue2Enabled",
    AccountPastDueOptOut = "AccountPastDueOptOut",
    AccountPayBill1 = "AccountPayBill1",
    AccountPayBill2 = "AccountPayBill2",
    AccountPayBill2Enabled = "AccountPayBill2Enabled",
    AccountPayBill3 = "AccountPayBill3",
    AccountPayBill3Enabled = "AccountPayBill3Enabled",
    AccountPaymentExtension1 = "AccountPaymentExtension1",
    AccountPaymentExtension2 = "AccountPaymentExtension2",
    AccountPaymentExtension2Enabled = "AccountPaymentExtension2Enabled",
    AccountPaymentHistory1 = "AccountPaymentHistory1",
    AccountPaymentHistory2 = "AccountPaymentHistory2",
    AccountPaymentHistory2Enabled = "AccountPaymentHistory2Enabled",
    AccountPaymentIssue1 = "AccountPaymentIssue1",
    AccountPaymentIssue2 = "AccountPaymentIssue2",
    AccountPaymentIssue2Enabled = "AccountPaymentIssue2Enabled",
    AccountReservation1 = "AccountReservation1",
    AccountReservation2 = "AccountReservation2",
    AccountReservation2Enabled = "AccountReservation2Enabled",
    AccountResetPassword1 = "AccountResetPassword1",
    AccountResetPassword2 = "AccountResetPassword2",
    AccountResetPassword2Enabled = "AccountResetPassword2Enabled",
    AccountUnitSize1 = "AccountUnitSize1",
    AccountUnitSize2 = "AccountUnitSize2",
    AccountUnitSize2Enabled = "AccountUnitSize2Enabled",
    AccountUpdateBillingInformation1 = "AccountUpdateBillingInformation1",
    AccountUpdateBillingInformation2 = "AccountUpdateBillingInformation2",
    AccountUpdateBillingInformation2Enabled = "AccountUpdateBillingInformation2Enabled",
    AccountUpdateBillingInformation3 = "AccountUpdateBillingInformation3",
    AccountUpdateBillingInformation3Enabled = "AccountUpdateBillingInformation3Enabled",
    AccountUpdateContactInformation1 = "AccountUpdateContactInformation1",
    AccountUpdateContactInformation2 = "AccountUpdateContactInformation2",
    AccountUpdateContactInformation2Enabled = "AccountUpdateContactInformation2Enabled",
    Address = "Address",
    AdminZipCollectQuestSlug = "AdminZipCollectQuestSlug",
    AfterHoursEmergencyPhone = "AfterHoursEmergencyPhone",
    AfterHoursPhoneNumber = "AfterHoursPhoneNumber",
    AfterNavigateAccountLoginAccountBalance = "AfterNavigateAccountLoginAccountBalance",
    AfterNavigateAccountLoginAccountBalance1 = "AfterNavigateAccountLoginAccountBalance1",
    AfterNavigateAccountLoginAccountBalance2 = "AfterNavigateAccountLoginAccountBalance2",
    AfterNavigateAccountLoginAccountBalance2Enabled = "AfterNavigateAccountLoginAccountBalance2Enabled",
    AfterNavigateAccountLoginAutopay = "AfterNavigateAccountLoginAutopay",
    AfterNavigateAccountLoginAutopay1 = "AfterNavigateAccountLoginAutopay1",
    AfterNavigateAccountLoginAutopay2 = "AfterNavigateAccountLoginAutopay2",
    AfterNavigateAccountLoginAutopay2Enabled = "AfterNavigateAccountLoginAutopay2Enabled",
    AfterNavigateAccountLoginAutopayQuestSlug = "AfterNavigateAccountLoginAutopayQuestSlug",
    AfterNavigateAccountLoginBillingDispute = "AfterNavigateAccountLoginBillingDispute",
    AfterNavigateAccountLoginBillingDispute1 = "AfterNavigateAccountLoginBillingDispute1",
    AfterNavigateAccountLoginBillingDispute2 = "AfterNavigateAccountLoginBillingDispute2",
    AfterNavigateAccountLoginBillingDispute2Enabled = "AfterNavigateAccountLoginBillingDispute2Enabled",
    AfterNavigateAccountLoginBillingIssue = "AfterNavigateAccountLoginBillingIssue",
    AfterNavigateAccountLoginBillingIssue1 = "AfterNavigateAccountLoginBillingIssue1",
    AfterNavigateAccountLoginBillingIssue2 = "AfterNavigateAccountLoginBillingIssue2",
    AfterNavigateAccountLoginBillingIssue2Enabled = "AfterNavigateAccountLoginBillingIssue2Enabled",
    AfterNavigateAccountLoginCancelService = "AfterNavigateAccountLoginCancelService",
    AfterNavigateAccountLoginCancelService1 = "AfterNavigateAccountLoginCancelService1",
    AfterNavigateAccountLoginCancelService2 = "AfterNavigateAccountLoginCancelService2",
    AfterNavigateAccountLoginCancelService2Enabled = "AfterNavigateAccountLoginCancelService2Enabled",
    AfterNavigateAccountLoginCancelServiceQuestSlug = "AfterNavigateAccountLoginCancelServiceQuestSlug",
    AfterNavigateAccountLoginCreateLogin = "AfterNavigateAccountLoginCreateLogin",
    AfterNavigateAccountLoginCreateLogin1 = "AfterNavigateAccountLoginCreateLogin1",
    AfterNavigateAccountLoginCreateLogin2 = "AfterNavigateAccountLoginCreateLogin2",
    AfterNavigateAccountLoginCreateLogin2Enabled = "AfterNavigateAccountLoginCreateLogin2Enabled",
    AfterNavigateAccountLoginCreateLoginQuestSlug = "AfterNavigateAccountLoginCreateLoginQuestSlug",
    AfterNavigateAccountLoginCreditDebit1 = "AfterNavigateAccountLoginCreditDebit1",
    AfterNavigateAccountLoginCreditDebit2 = "AfterNavigateAccountLoginCreditDebit2",
    AfterNavigateAccountLoginCreditDebit2Enabled = "AfterNavigateAccountLoginCreditDebit2Enabled",
    AfterNavigateAccountLoginCreditDebitQuestSlug = "AfterNavigateAccountLoginCreditDebitQuestSlug",
    AfterNavigateAccountLoginGetLease = "AfterNavigateAccountLoginGetLease",
    AfterNavigateAccountLoginGetLease1 = "AfterNavigateAccountLoginGetLease1",
    AfterNavigateAccountLoginGetLease2 = "AfterNavigateAccountLoginGetLease2",
    AfterNavigateAccountLoginGetLease2Enabled = "AfterNavigateAccountLoginGetLease2Enabled",
    AfterNavigateAccountLoginManageInsurance = "AfterNavigateAccountLoginManageInsurance",
    AfterNavigateAccountLoginManageInsurance1 = "AfterNavigateAccountLoginManageInsurance1",
    AfterNavigateAccountLoginManageInsurance2 = "AfterNavigateAccountLoginManageInsurance2",
    AfterNavigateAccountLoginManageInsurance2Enabled = "AfterNavigateAccountLoginManageInsurance2Enabled",
    AfterNavigateAccountLoginMultipleAccounts = "AfterNavigateAccountLoginMultipleAccounts",
    AfterNavigateAccountLoginMultipleAccounts1 = "AfterNavigateAccountLoginMultipleAccounts1",
    AfterNavigateAccountLoginMultipleAccounts2 = "AfterNavigateAccountLoginMultipleAccounts2",
    AfterNavigateAccountLoginMultipleAccounts2Enabled = "AfterNavigateAccountLoginMultipleAccounts2Enabled",
    AfterNavigateAccountLoginPartialPayment = "AfterNavigateAccountLoginPartialPayment",
    AfterNavigateAccountLoginPartialPayment1 = "AfterNavigateAccountLoginPartialPayment1",
    AfterNavigateAccountLoginPartialPayment2 = "AfterNavigateAccountLoginPartialPayment2",
    AfterNavigateAccountLoginPartialPayment2Enabled = "AfterNavigateAccountLoginPartialPayment2Enabled",
    AfterNavigateAccountLoginPassword = "AfterNavigateAccountLoginPassword",
    AfterNavigateAccountLoginPassword1 = "AfterNavigateAccountLoginPassword1",
    AfterNavigateAccountLoginPassword2 = "AfterNavigateAccountLoginPassword2",
    AfterNavigateAccountLoginPassword2Enabled = "AfterNavigateAccountLoginPassword2Enabled",
    AfterNavigateAccountLoginPasswordQuestSlug = "AfterNavigateAccountLoginPasswordQuestSlug",
    AfterNavigateAccountLoginPayBill = "AfterNavigateAccountLoginPayBill",
    AfterNavigateAccountLoginPayBill1 = "AfterNavigateAccountLoginPayBill1",
    AfterNavigateAccountLoginPayBill2 = "AfterNavigateAccountLoginPayBill2",
    AfterNavigateAccountLoginPayBill2Enabled = "AfterNavigateAccountLoginPayBill2Enabled",
    AfterNavigateAccountLoginPayBillQuestSlug = "AfterNavigateAccountLoginPayBillQuestSlug",
    AfterNavigateAccountLoginPaymentExtension = "AfterNavigateAccountLoginPaymentExtension",
    AfterNavigateAccountLoginPaymentExtension1 = "AfterNavigateAccountLoginPaymentExtension1",
    AfterNavigateAccountLoginPaymentExtension2 = "AfterNavigateAccountLoginPaymentExtension2",
    AfterNavigateAccountLoginPaymentExtension2Enabled = "AfterNavigateAccountLoginPaymentExtension2Enabled",
    AfterNavigateAccountLoginPaymentHistory = "AfterNavigateAccountLoginPaymentHistory",
    AfterNavigateAccountLoginPaymentHistory1 = "AfterNavigateAccountLoginPaymentHistory1",
    AfterNavigateAccountLoginPaymentHistory2 = "AfterNavigateAccountLoginPaymentHistory2",
    AfterNavigateAccountLoginPaymentHistory2Enabled = "AfterNavigateAccountLoginPaymentHistory2Enabled",
    AfterNavigateAccountLoginPaymentIssue = "AfterNavigateAccountLoginPaymentIssue",
    AfterNavigateAccountLoginPaymentIssue1 = "AfterNavigateAccountLoginPaymentIssue1",
    AfterNavigateAccountLoginPaymentIssue2 = "AfterNavigateAccountLoginPaymentIssue2",
    AfterNavigateAccountLoginPaymentIssue2Enabled = "AfterNavigateAccountLoginPaymentIssue2Enabled",
    AfterNavigateAccountLoginReservations = "AfterNavigateAccountLoginReservations",
    AfterNavigateAccountLoginReservations1 = "AfterNavigateAccountLoginReservations1",
    AfterNavigateAccountLoginReservations2 = "AfterNavigateAccountLoginReservations2",
    AfterNavigateAccountLoginReservations2Enabled = "AfterNavigateAccountLoginReservations2Enabled",
    AfterNavigateAccountLoginReservationsQuestSlug = "AfterNavigateAccountLoginReservationsQuestSlug",
    AfterNavigateAccountLoginUnitSize = "AfterNavigateAccountLoginUnitSize",
    AfterNavigateAccountLoginUnitSize1 = "AfterNavigateAccountLoginUnitSize1",
    AfterNavigateAccountLoginUnitSize2 = "AfterNavigateAccountLoginUnitSize2",
    AfterNavigateAccountLoginUnitSize2Enabled = "AfterNavigateAccountLoginUnitSize2Enabled",
    AfterNavigateAccountLoginUpdateBilling = "AfterNavigateAccountLoginUpdateBilling",
    AfterNavigateAccountLoginUpdateBilling1 = "AfterNavigateAccountLoginUpdateBilling1",
    AfterNavigateAccountLoginUpdateBilling2 = "AfterNavigateAccountLoginUpdateBilling2",
    AfterNavigateAccountLoginUpdateBilling2Enabled = "AfterNavigateAccountLoginUpdateBilling2Enabled",
    AfterNavigateAccountLoginUpdateBillingQuestSlug = "AfterNavigateAccountLoginUpdateBillingQuestSlug",
    AfterNavigateAccountLoginUpdateContact = "AfterNavigateAccountLoginUpdateContact",
    AfterNavigateAccountLoginUpdateContact1 = "AfterNavigateAccountLoginUpdateContact1",
    AfterNavigateAccountLoginUpdateContact2 = "AfterNavigateAccountLoginUpdateContact2",
    AfterNavigateAccountLoginUpdateContact2Enabled = "AfterNavigateAccountLoginUpdateContact2Enabled",
    AfterNavigateAccountLoginUpdateContactQuestSlug = "AfterNavigateAccountLoginUpdateContactQuestSlug",
    AfterNavigateAccountLoginUsername = "AfterNavigateAccountLoginUsername",
    AfterNavigateAccountLoginUsername1 = "AfterNavigateAccountLoginUsername1",
    AfterNavigateAccountLoginUsername2 = "AfterNavigateAccountLoginUsername2",
    AfterNavigateAccountLoginUsername2Enabled = "AfterNavigateAccountLoginUsername2Enabled",
    AfterNavigateAccountLoginUsernameQuestSlug = "AfterNavigateAccountLoginUsernameQuestSlug",
    AfterNavigateAuction = "AfterNavigateAuction",
    AfterNavigateAuction1 = "AfterNavigateAuction1",
    AfterNavigateAuction2 = "AfterNavigateAuction2",
    AfterNavigateAuction2Enabled = "AfterNavigateAuction2Enabled",
    AfterNavigateAuctionQuestSlug = "AfterNavigateAuctionQuestSlug",
    AfterNavigateCareers = "AfterNavigateCareers",
    AfterNavigateCareers1 = "AfterNavigateCareers1",
    AfterNavigateCareers2 = "AfterNavigateCareers2",
    AfterNavigateCareers2Enabled = "AfterNavigateCareers2Enabled",
    AfterNavigateCareersQuestSlug = "AfterNavigateCareersQuestSlug",
    AfterNavigateGMBAboutQuestSlug = "AfterNavigateGMBAboutQuestSlug",
    AfterNavigateGMBAccountLoginQuestSlug = "AfterNavigateGMBAccountLoginQuestSlug",
    AfterNavigateGMBAccountPayBillQuestSlug = "AfterNavigateGMBAccountPayBillQuestSlug",
    AfterNavigateGMBAuctionQuestSlug = "AfterNavigateGMBAuctionQuestSlug",
    AfterNavigateGMBAutoPayQuestSlug = "AfterNavigateGMBAutoPayQuestSlug",
    AfterNavigateGMBCareerQuestSlug = "AfterNavigateGMBCareerQuestSlug",
    AfterNavigateGMBCreateLoginQuestSlug = "AfterNavigateGMBCreateLoginQuestSlug",
    AfterNavigateGMBCreditDebitQuestSlug = "AfterNavigateGMBCreditDebitQuestSlug",
    AfterNavigateGMBInsuranceQuestSlug = "AfterNavigateGMBInsuranceQuestSlug",
    AfterNavigateGMBPasswordQuestSlug = "AfterNavigateGMBPasswordQuestSlug",
    AfterNavigateGMBPayBillQuestSlug = "AfterNavigateGMBPayBillQuestSlug",
    AfterNavigateGMBReferralQuestSlug = "AfterNavigateGMBReferralQuestSlug",
    AfterNavigateGMBReservationsQuestSlug = "AfterNavigateGMBReservationsQuestSlug",
    AfterNavigateGMBShowInventoryQuestSlug = "AfterNavigateGMBShowInventoryQuestSlug",
    AfterNavigateGMBSizeVisualsQuestSlug = "AfterNavigateGMBSizeVisualsQuestSlug",
    AfterNavigateGMBUpdateBillingQuestSlug = "AfterNavigateGMBUpdateBillingQuestSlug",
    AfterNavigateGMBUpdateContactQuestSlug = "AfterNavigateGMBUpdateContactQuestSlug",
    AfterNavigateGMBUsernameQuestSlug = "AfterNavigateGMBUsernameQuestSlug",
    AfterNavigateInsurance = "AfterNavigateInsurance",
    AfterNavigateInsurance1 = "AfterNavigateInsurance1",
    AfterNavigateInsurance2 = "AfterNavigateInsurance2",
    AfterNavigateInsurance2Enabled = "AfterNavigateInsurance2Enabled",
    AfterNavigateInsuranceQuestSlug = "AfterNavigateInsuranceQuestSlug",
    AfterNavigateMobileApp1 = "AfterNavigateMobileApp1",
    AfterNavigateReferral = "AfterNavigateReferral",
    AfterNavigateReferral1 = "AfterNavigateReferral1",
    AfterNavigateReferral2 = "AfterNavigateReferral2",
    AfterNavigateReferral2Enabled = "AfterNavigateReferral2Enabled",
    AfterNavigateReferralQuestSlug = "AfterNavigateReferralQuestSlug",
    AfterNavigateShowInventory1 = "AfterNavigateShowInventory1",
    AfterNavigateShowInventory2 = "AfterNavigateShowInventory2",
    AfterNavigateShowInventory2Enabled = "AfterNavigateShowInventory2Enabled",
    AfterNavigateShowInventoryQuestSlug = "AfterNavigateShowInventoryQuestSlug",
    AfterNavigateSizeVisuals = "AfterNavigateSizeVisuals",
    AfterNavigateSizeVisuals1 = "AfterNavigateSizeVisuals1",
    AfterNavigateSizeVisuals2 = "AfterNavigateSizeVisuals2",
    AfterNavigateSizeVisuals2Enabled = "AfterNavigateSizeVisuals2Enabled",
    AfterNavigateSizeVisualsQuestSlug = "AfterNavigateSizeVisualsQuestSlug",
    AfterNavigateSMSAboutQuestSlug = "AfterNavigateSMSAboutQuestSlug",
    AfterNavigateSMSAccountLoginCancelServiceQuestSlug = "AfterNavigateSMSAccountLoginCancelServiceQuestSlug",
    AfterNavigateSMSAccountLoginQuestSlug = "AfterNavigateSMSAccountLoginQuestSlug",
    AfterNavigateSMSAccountPayBillQuestSlug = "AfterNavigateSMSAccountPayBillQuestSlug",
    AfterNavigateSMSAuctionQuestSlug = "AfterNavigateSMSAuctionQuestSlug",
    AfterNavigateSMSAutoPayQuestSlug = "AfterNavigateSMSAutoPayQuestSlug",
    AfterNavigateSMSCareerQuestSlug = "AfterNavigateSMSCareerQuestSlug",
    AfterNavigateSMSCreateLoginQuestSlug = "AfterNavigateSMSCreateLoginQuestSlug",
    AfterNavigateSMSCreditDebitQuestSlug = "AfterNavigateSMSCreditDebitQuestSlug",
    AfterNavigateSMSInsuranceQuestSlug = "AfterNavigateSMSInsuranceQuestSlug",
    AfterNavigateSMSPasswordQuestSlug = "AfterNavigateSMSPasswordQuestSlug",
    AfterNavigateSMSPayBillQuestSlug = "AfterNavigateSMSPayBillQuestSlug",
    AfterNavigateSMSReferralQuestSlug = "AfterNavigateSMSReferralQuestSlug",
    AfterNavigateSMSReservationsQuestSlug = "AfterNavigateSMSReservationsQuestSlug",
    AfterNavigateSMSSelectStoreQuestSlug = "AfterNavigateSMSSelectStoreQuestSlug",
    AfterNavigateSMSShowInventoryQuestSlug = "AfterNavigateSMSShowInventoryQuestSlug",
    AfterNavigateSMSSizeVisualsQuestSlug = "AfterNavigateSMSSizeVisualsQuestSlug",
    AfterNavigateSMSUpdateBillingQuestSlug = "AfterNavigateSMSUpdateBillingQuestSlug",
    AfterNavigateSMSUpdateContactQuestSlug = "AfterNavigateSMSUpdateContactQuestSlug",
    AfterNavigateSMSUsernameQuestSlug = "AfterNavigateSMSUsernameQuestSlug",
    AgentAssistEnabled = "AgentAssistEnabled",
    AllowsReferralsInChat = "AllowsReferralsInChat",
    Appointment = "Appointment",
    AuctionsURL = "AuctionsURL",
    AvatarURL = "AvatarURL",
    BoatStorage = "BoatStorage",
    BoatStorage1 = "BoatStorage1",
    BoatStorage2 = "BoatStorage2",
    BoatStorage2Enabled = "BoatStorage2Enabled",
    BotName = "BotName",
    BrainSlug = "BrainSlug",
    BrandColor = "BrandColor",
    BrandId = "BrandId",
    BrandImage = "BrandImage",
    BusinessStorage = "BusinessStorage",
    CallCenterHours = "CallCenterHours",
    CareersURL = "CareersURL",
    ChangeDueDate1 = "ChangeDueDate1",
    ChangeDueDate2 = "ChangeDueDate2",
    ChangeDueDate2Enabled = "ChangeDueDate2Enabled",
    ChangeDueDate3 = "ChangeDueDate3",
    ChangeDueDate4 = "ChangeDueDate4",
    ChangeDueDate4Enabled = "ChangeDueDate4Enabled",
    ChangeDueDate5 = "ChangeDueDate5",
    ChangeDueDate6 = "ChangeDueDate6",
    ChangeDueDate6Enabled = "ChangeDueDate6Enabled",
    ChangeDueDate7 = "ChangeDueDate7",
    ChangeDueDate8 = "ChangeDueDate8",
    ChangeDueDate8Enabled = "ChangeDueDate8Enabled",
    ChangeDueDateSelection = "ChangeDueDateSelection",
    City = "City",
    ClimateControlDisplayName = "ClimateControlDisplayName",
    ClimateControlHighValue = "ClimateControlHighValue",
    ClimateControlLowValue = "ClimateControlLowValue",
    ClimateControlName = "ClimateControlName",
    ContactTagEmailList = "ContactTagEmailList",
    CortexCreateLeadForMovingTrucks = "CortexCreateLeadForMovingTrucks",
    CortexCurrencyCode = "CortexCurrencyCode",
    CortexCustomInstructions = "CortexCustomInstructions",
    CortexDiscountCustomDetails = "CortexDiscountCustomDetails",
    CortexDiscountCustomName = "CortexDiscountCustomName",
    CortexDiscountIntroductoryDetails = "CortexDiscountIntroductoryDetails",
    CortexDiscountLongTermDetails = "CortexDiscountLongTermDetails",
    CortexDiscountMilitaryDetails = "CortexDiscountMilitaryDetails",
    CortexDiscountSeniorDetails = "CortexDiscountSeniorDetails",
    CortexDiscountStudentDetails = "CortexDiscountStudentDetails",
    CortexEscalationPushbackMode = "CortexEscalationPushbackMode",
    CortexFacilityAccessHours = "CortexFacilityAccessHours",
    CortexFacilityAddress = "CortexFacilityAddress",
    CortexFacilityAfterHoursPhoneNumber = "CortexFacilityAfterHoursPhoneNumber",
    CortexFacilityBotName = "CortexFacilityBotName",
    CortexFacilityBrandId = "CortexFacilityBrandId",
    CortexFacilityCallCenterHours = "CortexFacilityCallCenterHours",
    CortexFacilityCity = "CortexFacilityCity",
    CortexFacilityCountryCode = "CortexFacilityCountryCode",
    CortexFacilityDMEmail = "CortexFacilityDMEmail",
    CortexFacilityDMName = "CortexFacilityDMName",
    CortexFacilityDMPhone = "CortexFacilityDMPhone",
    CortexFacilityEmail = "CortexFacilityEmail",
    CortexFacilityFMSId = "CortexFacilityFMSId",
    CortexFacilityFMSIntegrationId = "CortexFacilityFMSIntegrationId",
    CortexFacilityFMSSyncEnabled = "CortexFacilityFMSSyncEnabled",
    CortexFacilityGateCodeInstructions = "CortexFacilityGateCodeInstructions",
    CortexFacilityImageURL = "CortexFacilityImageURL",
    CortexFacilityLocationNumber = "CortexFacilityLocationNumber",
    CortexFacilityMapURL = "CortexFacilityMapURL",
    CortexFacilityMapURLEnabled = "CortexFacilityMapURLEnabled",
    CortexFacilityName = "CortexFacilityName",
    CortexFacilityOfficeHours = "CortexFacilityOfficeHours",
    CortexFacilityPayByPhoneNumber = "CortexFacilityPayByPhoneNumber",
    CortexFacilityPhone = "CortexFacilityPhone",
    CortexFacilityPostalCode = "CortexFacilityPostalCode",
    CortexFacilitySpecialHours = "CortexFacilitySpecialHours",
    CortexFacilityState = "CortexFacilityState",
    CortexFacilityTimezone = "CortexFacilityTimezone",
    CortexFacilityWebsiteURL = "CortexFacilityWebsiteURL",
    CortexFeatureAfterHoursAccess = "CortexFeatureAfterHoursAccess",
    CortexFeatureAfterHoursAccessBotWording = "CortexFeatureAfterHoursAccessBotWording",
    CortexFeatureAfterHoursAccessName = "CortexFeatureAfterHoursAccessName",
    CortexFeatureAirAndVacuumStationName = "CortexFeatureAirAndVacuumStationName",
    CortexFeatureAlarmName = "CortexFeatureAlarmName",
    CortexFeatureAppointments = "CortexFeatureAppointments",
    CortexFeatureAppointmentsBotWording = "CortexFeatureAppointmentsBotWording",
    CortexFeatureAppointmentsName = "CortexFeatureAppointmentsName",
    CortexFeatureBoatStorage = "CortexFeatureBoatStorage",
    CortexFeatureBoatStorageBotWording = "CortexFeatureBoatStorageBotWording",
    CortexFeatureBoatStorageName = "CortexFeatureBoatStorageName",
    CortexFeatureBusinessStorage = "CortexFeatureBusinessStorage",
    CortexFeatureBusinessStorageBotWording = "CortexFeatureBusinessStorageBotWording",
    CortexFeatureBusinessStorageName = "CortexFeatureBusinessStorageName",
    CortexFeatureClimateControl = "CortexFeatureClimateControl",
    CortexFeatureClimateControlBotWording = "CortexFeatureClimateControlBotWording",
    CortexFeatureClimateControlName = "CortexFeatureClimateControlName",
    CortexFeatureConferenceRoom = "CortexFeatureConferenceRoom",
    CortexFeatureConferenceRoomBotWording = "CortexFeatureConferenceRoomBotWording",
    CortexFeatureConferenceRoomName = "CortexFeatureConferenceRoomName",
    CortexFeatureCoveredName = "CortexFeatureCoveredName",
    CortexFeatureCoveredVehicleStorage = "CortexFeatureCoveredVehicleStorage",
    CortexFeatureCoveredVehicleStorageBotWording = "CortexFeatureCoveredVehicleStorageBotWording",
    CortexFeatureCoveredVehicleStorageName = "CortexFeatureCoveredVehicleStorageName",
    CortexFeatureDeliveriesAccepted = "CortexFeatureDeliveriesAccepted",
    CortexFeatureDeliveriesAcceptedBotWording = "CortexFeatureDeliveriesAcceptedBotWording",
    CortexFeatureDeliveriesAcceptedName = "CortexFeatureDeliveriesAcceptedName",
    CortexFeatureDollies = "CortexFeatureDollies",
    CortexFeatureDolliesBotWording = "CortexFeatureDolliesBotWording",
    CortexFeatureDolliesName = "CortexFeatureDolliesName",
    CortexFeatureDoubleDoorName = "CortexFeatureDoubleDoorName",
    CortexFeatureDriveUpAccess = "CortexFeatureDriveUpAccess",
    CortexFeatureDriveUpAccessBotWording = "CortexFeatureDriveUpAccessBotWording",
    CortexFeatureDriveUpAccessName = "CortexFeatureDriveUpAccessName",
    CortexFeatureDumpStation = "CortexFeatureDumpStation",
    CortexFeatureDumpStationBotWording = "CortexFeatureDumpStationBotWording",
    CortexFeatureDumpStationName = "CortexFeatureDumpStationName",
    CortexFeatureDumpsters = "CortexFeatureDumpsters",
    CortexFeatureDumpstersBotWording = "CortexFeatureDumpstersBotWording",
    CortexFeatureDumpstersName = "CortexFeatureDumpstersName",
    CortexFeatureElectricityInUnit = "CortexFeatureElectricityInUnit",
    CortexFeatureElectricityInUnitBotWording = "CortexFeatureElectricityInUnitBotWording",
    CortexFeatureElectricityInUnitName = "CortexFeatureElectricityInUnitName",
    CortexFeatureElevators = "CortexFeatureElevators",
    CortexFeatureElevatorsBotWording = "CortexFeatureElevatorsBotWording",
    CortexFeatureElevatorsName = "CortexFeatureElevatorsName",
    CortexFeatureEnclosedName = "CortexFeatureEnclosedName",
    CortexFeatureFirstFloorName = "CortexFeatureFirstFloorName",
    CortexFeatureGunStorageName = "CortexFeatureGunStorageName",
    CortexFeatureHeatedUnits = "CortexFeatureHeatedUnits",
    CortexFeatureHeatedUnitsBotWording = "CortexFeatureHeatedUnitsBotWording",
    CortexFeatureHeatedUnitsName = "CortexFeatureHeatedUnitsName",
    CortexFeatureHighCeilingName = "CortexFeatureHighCeilingName",
    CortexFeatureHumidityControl = "CortexFeatureHumidityControl",
    CortexFeatureHumidityControlBotWording = "CortexFeatureHumidityControlBotWording",
    CortexFeatureHumidityControlName = "CortexFeatureHumidityControlName",
    CortexFeatureIndoorVehicleStorage = "CortexFeatureIndoorVehicleStorage",
    CortexFeatureIndoorVehicleStorageBotWording = "CortexFeatureIndoorVehicleStorageBotWording",
    CortexFeatureIndoorVehicleStorageName = "CortexFeatureIndoorVehicleStorageName",
    CortexFeatureInsideName = "CortexFeatureInsideName",
    CortexFeatureLargeRollDoorName = "CortexFeatureLargeRollDoorName",
    CortexFeatureLightInUnitName = "CortexFeatureLightInUnitName",
    CortexFeatureLockers = "CortexFeatureLockers",
    CortexFeatureLockersBotWording = "CortexFeatureLockersBotWording",
    CortexFeatureLockersName = "CortexFeatureLockersName",
    CortexFeatureMovingServices = "CortexFeatureMovingServices",
    CortexFeatureMovingServicesBotWording = "CortexFeatureMovingServicesBotWording",
    CortexFeatureMovingServicesName = "CortexFeatureMovingServicesName",
    CortexFeatureMovingTrucks = "CortexFeatureMovingTrucks",
    CortexFeatureMovingTrucksBotWording = "CortexFeatureMovingTrucksBotWording",
    CortexFeatureMovingTrucksName = "CortexFeatureMovingTrucksName",
    CortexFeatureNotary = "CortexFeatureNotary",
    CortexFeatureNotaryBotWording = "CortexFeatureNotaryBotWording",
    CortexFeatureNotaryName = "CortexFeatureNotaryName",
    CortexFeatureObstructionName = "CortexFeatureObstructionName",
    CortexFeatureOddShapedName = "CortexFeatureOddShapedName",
    CortexFeatureOfficeSpace = "CortexFeatureOfficeSpace",
    CortexFeatureOfficeSpaceBotWording = "CortexFeatureOfficeSpaceBotWording",
    CortexFeatureOfficeSpaceName = "CortexFeatureOfficeSpaceName",
    CortexFeatureOnSiteManager = "CortexFeatureOnSiteManager",
    CortexFeatureOnSiteManagerBotWording = "CortexFeatureOnSiteManagerBotWording",
    CortexFeatureOnSiteManagerName = "CortexFeatureOnSiteManagerName",
    CortexFeaturePackingSupplies = "CortexFeaturePackingSupplies",
    CortexFeaturePackingSuppliesBotWording = "CortexFeaturePackingSuppliesBotWording",
    CortexFeaturePackingSuppliesName = "CortexFeaturePackingSuppliesName",
    CortexFeaturePadlocks = "CortexFeaturePadlocks",
    CortexFeaturePadlocksBotWording = "CortexFeaturePadlocksBotWording",
    CortexFeaturePadlocksName = "CortexFeaturePadlocksName",
    CortexFeaturePavedName = "CortexFeaturePavedName",
    CortexFeaturePOMailbox = "CortexFeaturePOMailbox",
    CortexFeaturePOMailboxBotWording = "CortexFeaturePOMailboxBotWording",
    CortexFeaturePOMailboxName = "CortexFeaturePOMailboxName",
    CortexFeaturePortableUnits = "CortexFeaturePortableUnits",
    CortexFeaturePortableUnitsBotWording = "CortexFeaturePortableUnitsBotWording",
    CortexFeaturePortableUnitsName = "CortexFeaturePortableUnitsName",
    CortexFeaturePropane = "CortexFeaturePropane",
    CortexFeaturePropaneBotWording = "CortexFeaturePropaneBotWording",
    CortexFeaturePropaneName = "CortexFeaturePropaneName",
    CortexFeaturePullThruName = "CortexFeaturePullThruName",
    CortexFeatureRecycleProgram = "CortexFeatureRecycleProgram",
    CortexFeatureRecycleProgramBotWording = "CortexFeatureRecycleProgramBotWording",
    CortexFeatureRecycleProgramName = "CortexFeatureRecycleProgramName",
    CortexFeatureRinseStationName = "CortexFeatureRinseStationName",
    CortexFeatureRollDoorName = "CortexFeatureRollDoorName",
    CortexFeatureRVParking = "CortexFeatureRVParking",
    CortexFeatureRVParkingBotWording = "CortexFeatureRVParkingBotWording",
    CortexFeatureRVParkingCovered = "CortexFeatureRVParkingCovered",
    CortexFeatureRVParkingCoveredBotWording = "CortexFeatureRVParkingCoveredBotWording",
    CortexFeatureRVParkingCoveredName = "CortexFeatureRVParkingCoveredName",
    CortexFeatureRVParkingEnclosed = "CortexFeatureRVParkingEnclosed",
    CortexFeatureRVParkingEnclosedBotWording = "CortexFeatureRVParkingEnclosedBotWording",
    CortexFeatureRVParkingEnclosedName = "CortexFeatureRVParkingEnclosedName",
    CortexFeatureRVParkingName = "CortexFeatureRVParkingName",
    CortexFeatureSafetyDepositBoxName = "CortexFeatureSafetyDepositBoxName",
    CortexFeatureShredProgram = "CortexFeatureShredProgram",
    CortexFeatureShredProgramBotWording = "CortexFeatureShredProgramBotWording",
    CortexFeatureShredProgramName = "CortexFeatureShredProgramName",
    CortexFeatureSmallRollDoorName = "CortexFeatureSmallRollDoorName",
    CortexFeatureSmallVehicleStorage = "CortexFeatureSmallVehicleStorage",
    CortexFeatureSmallVehicleStorageBotWording = "CortexFeatureSmallVehicleStorageBotWording",
    CortexFeatureSmallVehicleStorageName = "CortexFeatureSmallVehicleStorageName",
    CortexFeatureStorageUnitName = "CortexFeatureStorageUnitName",
    CortexFeatureSwingDoorName = "CortexFeatureSwingDoorName",
    CortexFeatureTrailerStorage = "CortexFeatureTrailerStorage",
    CortexFeatureTrailerStorageBotWording = "CortexFeatureTrailerStorageBotWording",
    CortexFeatureTrailerStorageName = "CortexFeatureTrailerStorageName",
    CortexFeatureTwentyFourHourAccess = "CortexFeatureTwentyFourHourAccess",
    CortexFeatureTwentyFourHourAccessBotWording = "CortexFeatureTwentyFourHourAccessBotWording",
    CortexFeatureTwentyFourHourAccessName = "CortexFeatureTwentyFourHourAccessName",
    CortexFeatureUnpavedName = "CortexFeatureUnpavedName",
    CortexFeatureUpperLevelName = "CortexFeatureUpperLevelName",
    CortexFeatureVehicleStorage = "CortexFeatureVehicleStorage",
    CortexFeatureVehicleStorageBotWording = "CortexFeatureVehicleStorageBotWording",
    CortexFeatureVehicleStorageName = "CortexFeatureVehicleStorageName",
    CortexFeatureVideoSurveillance = "CortexFeatureVideoSurveillance",
    CortexFeatureVideoSurveillanceBotWording = "CortexFeatureVideoSurveillanceBotWording",
    CortexFeatureVideoSurveillanceName = "CortexFeatureVideoSurveillanceName",
    CortexFeatureWineStorage = "CortexFeatureWineStorage",
    CortexFeatureWineStorageBotWording = "CortexFeatureWineStorageBotWording",
    CortexFeatureWineStorageName = "CortexFeatureWineStorageName",
    CortexIsSingleLocation = "CortexIsSingleLocation",
    CortexIsSMSCampaignsEnabled = "CortexIsSMSCampaignsEnabled",
    CortexLengthUnit = "CortexLengthUnit",
    CortexMoveOutFormURL = "CortexMoveOutFormURL",
    CortexPersona = "CortexPersona",
    CortexProfanityHandlingOnProfanity = "CortexProfanityHandlingOnProfanity",
    CortexPushConversationSummaryToFms = "CortexPushConversationSummaryToFms",
    CortexSingleLocation = "CortexSingleLocation",
    CortexSizeGuide = "CortexSizeGuide",
    CortexSpotBrandSlug = "CortexSpotBrandSlug",
    CortexSpotLinkSlug = "CortexSpotLinkSlug",
    CortexSpotLocationSlug = "CortexSpotLocationSlug",
    CortexSpotReferralURL = "CortexSpotReferralURL",
    CortexStoragelyClientID = "CortexStoragelyClientID",
    CortexStoragePugSingleLocationBaseURL = "CortexStoragePugSingleLocationBaseURL",
    CortexTenantPageLinksEnabled = "CortexTenantPageLinksEnabled",
    CortexURLAccountLogin = "CortexURLAccountLogin",
    CortexURLAccountLoginEnabled = "CortexURLAccountLoginEnabled",
    CortexURLAuctions = "CortexURLAuctions",
    CortexURLAuctionsEnabled = "CortexURLAuctionsEnabled",
    CortexURLCareer = "CortexURLCareer",
    CortexURLCareerEnabled = "CortexURLCareerEnabled",
    CortexURLGoogleReview = "CortexURLGoogleReview",
    CortexURLGoogleReviewEnabled = "CortexURLGoogleReviewEnabled",
    CortexURLInsurance = "CortexURLInsurance",
    CortexURLInsuranceEnabled = "CortexURLInsuranceEnabled",
    CortexURLLookupPattern = "CortexURLLookupPattern",
    CortexURLMobileApp = "CortexURLMobileApp",
    CortexURLMobileAppEnabled = "CortexURLMobileAppEnabled",
    CortexURLMovingServices = "CortexURLMovingServices",
    CortexURLMovingServicesEnabled = "CortexURLMovingServicesEnabled",
    CortexURLPackingSupplies = "CortexURLPackingSupplies",
    CortexURLPackingSuppliesEnabled = "CortexURLPackingSuppliesEnabled",
    CortexURLPayOnline = "CortexURLPayOnline",
    CortexURLPayOnlineEnabled = "CortexURLPayOnlineEnabled",
    CortexURLPrivacyPolicy = "CortexURLPrivacyPolicy",
    CortexURLPrivacyPolicyEnabled = "CortexURLPrivacyPolicyEnabled",
    CortexURLReferral = "CortexURLReferral",
    CortexURLReferralEnabled = "CortexURLReferralEnabled",
    CortexURLSizeGuide = "CortexURLSizeGuide",
    CortexURLSizeGuideEnabled = "CortexURLSizeGuideEnabled",
    CortexVoicePreWelcomeMessage = "CortexVoicePreWelcomeMessage",
    CortexWebsiteProvider = "CortexWebsiteProvider",
    CortexWelcomeMessageKnownCustomerSms = "CortexWelcomeMessageKnownCustomerSms",
    CortexWelcomeMessageKnownCustomerVoice = "CortexWelcomeMessageKnownCustomerVoice",
    CortexWelcomeMessageKnownCustomerWeb = "CortexWelcomeMessageKnownCustomerWeb",
    CortexWelcomeMessageReturningUserSms = "CortexWelcomeMessageReturningUserSms",
    CortexWelcomeMessageReturningUserVoice = "CortexWelcomeMessageReturningUserVoice",
    CortexWelcomeMessageReturningUserWeb = "CortexWelcomeMessageReturningUserWeb",
    CortexWelcomeMessagesEnabled = "CortexWelcomeMessagesEnabled",
    CortexWelcomeMessageUnknownSms = "CortexWelcomeMessageUnknownSms",
    CortexWelcomeMessageUnknownVoice = "CortexWelcomeMessageUnknownVoice",
    CortexWelcomeMessageUnknownWeb = "CortexWelcomeMessageUnknownWeb",
    CostAdminFee1 = "CostAdminFee1",
    CostAdminFee2 = "CostAdminFee2",
    CostAdminFee2Enabled = "CostAdminFee2Enabled",
    CostCreditCardFee1 = "CostCreditCardFee1",
    CostCreditCardFee2 = "CostCreditCardFee2",
    CostCreditCardFee2Enabled = "CostCreditCardFee2Enabled",
    CostInsurance1 = "CostInsurance1",
    CostLateFee1 = "CostLateFee1",
    CostLateFee2 = "CostLateFee2",
    CostLateFee2Enabled = "CostLateFee2Enabled",
    CostRateIncrease1 = "CostRateIncrease1",
    CostRateIncrease2 = "CostRateIncrease2",
    CostRateIncrease2Enabled = "CostRateIncrease2Enabled",
    CostWebRates1 = "CostWebRates1",
    CostWebRates2 = "CostWebRates2",
    CostWebRates2Enabled = "CostWebRates2Enabled",
    CountryCode = "CountryCode",
    CTAhasURLNavigateTo = "CTAhasURLNavigateTo",
    CTAMessage1 = "CTAMessage1",
    CTAMessage2 = "CTAMessage2",
    CTAMessage2Enabled = "CTAMessage2Enabled",
    CTAMessage3 = "CTAMessage3",
    CTAMessage3Enabled = "CTAMessage3Enabled",
    CTAURLNavigateTo = "CTAURLNavigateTo",
    CTAURLNavigateToMessage1 = "CTAURLNavigateToMessage1",
    CustomerInitiatedEscalationsCollectProfile = "CustomerInitiatedEscalationsCollectProfile",
    CustomVariable1 = "CustomVariable1",
    CustomVariable2 = "CustomVariable2",
    CustomVariable3 = "CustomVariable3",
    DaVinciCodeDeliveryChannel = "DaVinciCodeDeliveryChannel",
    DaVinciCodeSMSMessage = "DaVinciCodeSMSMessage",
    DefaultCountry = "DefaultCountry",
    DefaultLanguage = "DefaultLanguage",
    DiscountCode = "DiscountCode",
    DiscountCodeDescription = "DiscountCodeDescription",
    DiscountCodeDisplayName = "DiscountCodeDisplayName",
    DiscountCustomDiscount1 = "DiscountCustomDiscount1",
    DiscountCustomDisplayName = "DiscountCustomDisplayName",
    DiscountIntroductory1 = "DiscountIntroductory1",
    DiscountLongTerm1 = "DiscountLongTerm1",
    DiscountMilitary1 = "DiscountMilitary1",
    DiscountSenior1 = "DiscountSenior1",
    DiscountStudent1 = "DiscountStudent1",
    DMEmail = "DMEmail",
    DMName = "DMName",
    DMPhone = "DMPhone",
    dontUseURLToSetStore = "dontUseURLToSetStore",
    Email = "Email",
    EnableAbandonedCartSequence = "EnableAbandonedCartSequence",
    EscalationTagEmailList = "EscalationTagEmailList",
    ExistingPersonaEmailList = "ExistingPersonaEmailList",
    ExtraLargeUnit = "ExtraLargeUnit",
    FacebookMessengerAppId = "FacebookMessengerAppId",
    FeatureAuction1 = "FeatureAuction1",
    FeatureClimateControl1 = "FeatureClimateControl1",
    FeatureClimateControl2 = "FeatureClimateControl2",
    FeatureClimateControl2Enabled = "FeatureClimateControl2Enabled",
    FeatureDriveUp1 = "FeatureDriveUp1",
    FeatureDriveUp2 = "FeatureDriveUp2",
    FeatureDriveUp2Enabled = "FeatureDriveUp2Enabled",
    FeatureDumpStation1 = "FeatureDumpStation1",
    FeatureLights1 = "FeatureLights1",
    FeatureMaintenancePest1 = "FeatureMaintenancePest1",
    FeatureMaintenancePest2 = "FeatureMaintenancePest2",
    FeatureMaintenancePest2Enabled = "FeatureMaintenancePest2Enabled",
    FeatureMovingServices1 = "FeatureMovingServices1",
    FeatureMovingServices2 = "FeatureMovingServices2",
    FeatureMovingServices2Enabled = "FeatureMovingServices2Enabled",
    FeaturePadlocks1 = "FeaturePadlocks1",
    FeaturePadlocks2 = "FeaturePadlocks2",
    FeaturePropane1 = "FeaturePropane1",
    FeatureReferral1 = "FeatureReferral1",
    FeatureReferral2 = "FeatureReferral2",
    FeatureReferral2Enabled = "FeatureReferral2Enabled",
    FeatureSecurity1 = "FeatureSecurity1",
    FeatureWineStorage1 = "FeatureWineStorage1",
    FeatureWineStorage2 = "FeatureWineStorage2",
    FeatureWineStorage2Enabled = "FeatureWineStorage2Enabled",
    FeatureWonAuction1 = "FeatureWonAuction1",
    FeatureWonAuction2 = "FeatureWonAuction2",
    FeatureWonAuction2Enabled = "FeatureWonAuction2Enabled",
    FirstFloorDisplayName = "FirstFloorDisplayName",
    FMSAccountBalanceChannel = "FMSAccountBalanceChannel",
    FMSAccountBalanceSMSMessage = "FMSAccountBalanceSMSMessage",
    FMSAccountNumberChannel = "FMSAccountNumberChannel",
    FMSAccountNumberSMSMessage = "FMSAccountNumberSMSMessage",
    FMSGateCodeChannel = "FMSGateCodeChannel",
    FMSGateCodeChannelSMSMessage = "FMSGateCodeChannelSMSMessage",
    FMSId = "FMSId",
    FMSIntegrationId = "FMSIntegrationId",
    FMSisLeadSentPersonaExisting = "FMSisLeadSentPersonaExisting",
    FMSisLeadSentPersonaPotential = "FMSisLeadSentPersonaPotential",
    FMSisLeadSentPersonaUnknown = "FMSisLeadSentPersonaUnknown",
    FMSisLeadSentTagContact = "FMSisLeadSentTagContact",
    FMSisLeadSentTagEscalation = "FMSisLeadSentTagEscalation",
    FMSisLeadSentTagProblem = "FMSisLeadSentTagProblem",
    FMSisLeadSentTagSales = "FMSisLeadSentTagSales",
    FMSisLeadSentTagService = "FMSisLeadSentTagService",
    FMSisLeadSentTagUnknown = "FMSisLeadSentTagUnknown",
    FMSisLeadSentTagWaitlist = "FMSisLeadSentTagWaitlist",
    FMSplus0AbandonedCart2Shortlink = "FMSplus0AbandonedCart2Shortlink",
    FMSplus0AbandonedCartEmailEnabled = "FMSplus0AbandonedCartEmailEnabled",
    FMSplus0AbandonedCartEmailShortlink = "FMSplus0AbandonedCartEmailShortlink",
    FMSplus0AbandonedCartSMSEnabled = "FMSplus0AbandonedCartSMSEnabled",
    FMSplus0AbandonedCartSMSShortlink = "FMSplus0AbandonedCartSMSShortlink",
    FMSplus0AbandonedCartVoiceEnabled = "FMSplus0AbandonedCartVoiceEnabled",
    FMSplus0AbandonedCartVoiceMessage = "FMSplus0AbandonedCartVoiceMessage",
    FMSplus0MoveIn1 = "FMSplus0MoveIn1",
    FMSplus0MoveIn2 = "FMSplus0MoveIn2",
    FMSplus0MoveIn2Enabled = "FMSplus0MoveIn2Enabled",
    FMSplus0MoveIn3 = "FMSplus0MoveIn3",
    FMSplus0MoveIn3Enabled = "FMSplus0MoveIn3Enabled",
    FMSplus0MoveInReferral = "FMSplus0MoveInReferral",
    FMSplus0MoveInReferral1 = "FMSplus0MoveInReferral1",
    FMSplus0MoveInReview = "FMSplus0MoveInReview",
    FMSplus0MoveOut1 = "FMSplus0MoveOut1",
    FMSplus0MoveOut2 = "FMSplus0MoveOut2",
    FMSplus0MoveOut2Enabled = "FMSplus0MoveOut2Enabled",
    FMSplus0MoveOut3 = "FMSplus0MoveOut3",
    FMSplus0MoveOut3Enabled = "FMSplus0MoveOut3Enabled",
    FMSplus0MoveOutReview = "FMSplus0MoveOutReview",
    FMSplus0PastDue1 = "FMSplus0PastDue1",
    FMSplus0PastDue2 = "FMSplus0PastDue2",
    FMSplus0PastDue2Enabled = "FMSplus0PastDue2Enabled",
    FMSplus0PastDue2Shortlink = "FMSplus0PastDue2Shortlink",
    FMSplus0PastDue3 = "FMSplus0PastDue3",
    FMSplus0PastDue3Enabled = "FMSplus0PastDue3Enabled",
    FMSplus0PastDueEmailEnabled = "FMSplus0PastDueEmailEnabled",
    FMSplus0PastDueEmailShortlink = "FMSplus0PastDueEmailShortlink",
    FMSplus0PastDueSMSEnabled = "FMSplus0PastDueSMSEnabled",
    FMSplus0PastDueSMSShortlink = "FMSplus0PastDueSMSShortlink",
    FMSplus0PastDueVoiceEnabled = "FMSplus0PastDueVoiceEnabled",
    FMSplus0PastDueVoiceMessage = "FMSplus0PastDueVoiceMessage",
    FMSplus0PaymentDue1 = "FMSplus0PaymentDue1",
    FMSplus0PaymentDue2 = "FMSplus0PaymentDue2",
    FMSplus0PaymentDue2Enabled = "FMSplus0PaymentDue2Enabled",
    FMSplus0PaymentDue3 = "FMSplus0PaymentDue3",
    FMSplus0PaymentDue3Enabled = "FMSplus0PaymentDue3Enabled",
    FMSplus0PaymentMethodExpiring1 = "FMSplus0PaymentMethodExpiring1",
    FMSplus0PaymentMethodExpiring2 = "FMSplus0PaymentMethodExpiring2",
    FMSplus0PaymentMethodExpiring2Enabled = "FMSplus0PaymentMethodExpiring2Enabled",
    FMSplus0PaymentMethodExpiring3 = "FMSplus0PaymentMethodExpiring3",
    FMSplus0PaymentMethodExpiring3Enabled = "FMSplus0PaymentMethodExpiring3Enabled",
    FMSplus0PaymentSuccess1 = "FMSplus0PaymentSuccess1",
    FMSplus0PaymentSuccess2 = "FMSplus0PaymentSuccess2",
    FMSplus0PaymentSuccess2Enabled = "FMSplus0PaymentSuccess2Enabled",
    FMSplus0PaymentSuccess3 = "FMSplus0PaymentSuccess3",
    FMSplus0PaymentSuccess3Enabled = "FMSplus0PaymentSuccess3Enabled",
    FMSplus0UpdateContactInfo1 = "FMSplus0UpdateContactInfo1",
    FMSplus0UpdateContactInfo2 = "FMSplus0UpdateContactInfo2",
    FMSplus0UpdateContactInfo2Enabled = "FMSplus0UpdateContactInfo2Enabled",
    FMSplus0UpdateContactInfo3 = "FMSplus0UpdateContactInfo3",
    FMSplus0UpdateContactInfo3Enabled = "FMSplus0UpdateContactInfo3Enabled",
    FMSplusAbandonedCartsShortlinksEnabled = "FMSplusAbandonedCartsShortlinksEnabled",
    FMSplushas0AbandonedCart1 = "FMSplushas0AbandonedCart1",
    FMSplushas0AbandonedCart2 = "FMSplushas0AbandonedCart2",
    FMSplushas0AbandonedCart2Enabled = "FMSplushas0AbandonedCart2Enabled",
    FMSplushas0AbandonedCartMethod = "FMSplushas0AbandonedCartMethod",
    FMSplushas0MoveIn = "FMSplushas0MoveIn",
    FMSplushas0MoveInMethod = "FMSplushas0MoveInMethod",
    FMSplushas0MoveOut = "FMSplushas0MoveOut",
    FMSplushas0MoveOutMethod = "FMSplushas0MoveOutMethod",
    FMSplushas0PastDue = "FMSplushas0PastDue",
    FMSplushas0PastDueMethod = "FMSplushas0PastDueMethod",
    FMSplushas0PaymentDue = "FMSplushas0PaymentDue",
    FMSplushas0PaymentDueMethod = "FMSplushas0PaymentDueMethod",
    FMSplushas0PaymentMethodExpiring = "FMSplushas0PaymentMethodExpiring",
    FMSplushas0PaymentMethodExpiringMethod = "FMSplushas0PaymentMethodExpiringMethod",
    FMSplushas0PaymentSuccess = "FMSplushas0PaymentSuccess",
    FMSplushas0PaymentSuccessMethod = "FMSplushas0PaymentSuccessMethod",
    FMSplushas0UpdateContactInfo = "FMSplushas0UpdateContactInfo",
    FMSplushas0UpdateContactInfoMethod = "FMSplushas0UpdateContactInfoMethod",
    FMSplushasn14PaymentMethodExpiring = "FMSplushasn14PaymentMethodExpiring",
    FMSplushasn14PaymentMethodExpiringMethod = "FMSplushasn14PaymentMethodExpiringMethod",
    FMSplushasn1PaymentDue = "FMSplushasn1PaymentDue",
    FMSplushasn1PaymentDueMethod = "FMSplushasn1PaymentDueMethod",
    FMSplushasn1PaymentMethodExpiring = "FMSplushasn1PaymentMethodExpiring",
    FMSplushasn1PaymentMethodExpiringMethod = "FMSplushasn1PaymentMethodExpiringMethod",
    FMSplushasn2PaymentDue = "FMSplushasn2PaymentDue",
    FMSplushasn2PaymentDueMethod = "FMSplushasn2PaymentDueMethod",
    FMSplushasn30PaymentMethodExpiring = "FMSplushasn30PaymentMethodExpiring",
    FMSplushasn30PaymentMethodExpiringMethod = "FMSplushasn30PaymentMethodExpiringMethod",
    FMSplushasn3PaymentDue = "FMSplushasn3PaymentDue",
    FMSplushasn3PaymentDueMethod = "FMSplushasn3PaymentDueMethod",
    FMSplushasn5PaymentDue = "FMSplushasn5PaymentDue",
    FMSplushasn5PaymentDueMethod = "FMSplushasn5PaymentDueMethod",
    FMSplushasn7PaymentDue = "FMSplushasn7PaymentDue",
    FMSplushasn7PaymentDueMethod = "FMSplushasn7PaymentDueMethod",
    FMSplushasn7PaymentMethodExpiring = "FMSplushasn7PaymentMethodExpiring",
    FMSplushasn7PaymentMethodExpiringMethod = "FMSplushasn7PaymentMethodExpiringMethod",
    FMSplushasp10AbandonedCart = "FMSplushasp10AbandonedCart",
    FMSplushasp10AbandonedCart1 = "FMSplushasp10AbandonedCart1",
    FMSplushasp10AbandonedCart2 = "FMSplushasp10AbandonedCart2",
    FMSplushasp10AbandonedCart2Enabled = "FMSplushasp10AbandonedCart2Enabled",
    FMSplushasp10AbandonedCartMethod = "FMSplushasp10AbandonedCartMethod",
    FMSplushasp10MoveIn = "FMSplushasp10MoveIn",
    FMSplushasp10MoveInMethod = "FMSplushasp10MoveInMethod",
    FMSplushasp10MoveInReferral = "FMSplushasp10MoveInReferral",
    FMSplushasp10MoveInReferral1 = "FMSplushasp10MoveInReferral1",
    FMSplushasp10MoveInReview = "FMSplushasp10MoveInReview",
    FMSplushasp10MoveOut = "FMSplushasp10MoveOut",
    FMSplushasp10MoveOutMethod = "FMSplushasp10MoveOutMethod",
    FMSplushasp10MoveOutReview = "FMSplushasp10MoveOutReview",
    FMSplushasp10PastDue = "FMSplushasp10PastDue",
    FMSplushasp10PastDueMethod = "FMSplushasp10PastDueMethod",
    FMSplushasp14AbandonedCart = "FMSplushasp14AbandonedCart",
    FMSplushasp14AbandonedCart1 = "FMSplushasp14AbandonedCart1",
    FMSplushasp14AbandonedCart2 = "FMSplushasp14AbandonedCart2",
    FMSplushasp14AbandonedCart2Enabled = "FMSplushasp14AbandonedCart2Enabled",
    FMSplushasp14AbandonedCartMethod = "FMSplushasp14AbandonedCartMethod",
    FMSplushasp14MoveIn = "FMSplushasp14MoveIn",
    FMSplushasp14MoveInMethod = "FMSplushasp14MoveInMethod",
    FMSplushasp14MoveInReferral = "FMSplushasp14MoveInReferral",
    FMSplushasp14MoveInReferral1 = "FMSplushasp14MoveInReferral1",
    FMSplushasp14MoveInReview = "FMSplushasp14MoveInReview",
    FMSplushasp14MoveOut = "FMSplushasp14MoveOut",
    FMSplushasp14MoveOutMethod = "FMSplushasp14MoveOutMethod",
    FMSplushasp14MoveOutReview = "FMSplushasp14MoveOutReview",
    FMSplushasp14PastDue = "FMSplushasp14PastDue",
    FMSplushasp14PastDueMethod = "FMSplushasp14PastDueMethod",
    FMSplushasp1AbandonedCart = "FMSplushasp1AbandonedCart",
    FMSplushasp1AbandonedCart1 = "FMSplushasp1AbandonedCart1",
    FMSplushasp1AbandonedCart2 = "FMSplushasp1AbandonedCart2",
    FMSplushasp1AbandonedCart2Enabled = "FMSplushasp1AbandonedCart2Enabled",
    FMSplushasp1AbandonedCartMethod = "FMSplushasp1AbandonedCartMethod",
    FMSplushasp1MoveIn = "FMSplushasp1MoveIn",
    FMSplushasp1MoveInMethod = "FMSplushasp1MoveInMethod",
    FMSplushasp1MoveInReferral = "FMSplushasp1MoveInReferral",
    FMSplushasp1MoveInReferral1 = "FMSplushasp1MoveInReferral1",
    FMSplushasp1MoveInReview = "FMSplushasp1MoveInReview",
    FMSplushasp1MoveOut = "FMSplushasp1MoveOut",
    FMSplushasp1MoveOutMethod = "FMSplushasp1MoveOutMethod",
    FMSplushasp1MoveOutReview = "FMSplushasp1MoveOutReview",
    FMSplushasp1PastDue = "FMSplushasp1PastDue",
    FMSplushasp1PastDueMethod = "FMSplushasp1PastDueMethod",
    FMSplushasp2AbandonedCart = "FMSplushasp2AbandonedCart",
    FMSplushasp2AbandonedCart1 = "FMSplushasp2AbandonedCart1",
    FMSplushasp2AbandonedCart2 = "FMSplushasp2AbandonedCart2",
    FMSplushasp2AbandonedCart2Enabled = "FMSplushasp2AbandonedCart2Enabled",
    FMSplushasp2AbandonedCartMethod = "FMSplushasp2AbandonedCartMethod",
    FMSplushasp2PastDue = "FMSplushasp2PastDue",
    FMSplushasp2PastDueMethod = "FMSplushasp2PastDueMethod",
    FMSplushasp30AbandonedCart = "FMSplushasp30AbandonedCart",
    FMSplushasp30AbandonedCart1 = "FMSplushasp30AbandonedCart1",
    FMSplushasp30AbandonedCart2 = "FMSplushasp30AbandonedCart2",
    FMSplushasp30AbandonedCart2Enabled = "FMSplushasp30AbandonedCart2Enabled",
    FMSplushasp30AbandonedCartMethod = "FMSplushasp30AbandonedCartMethod",
    FMSplushasp30MoveIn = "FMSplushasp30MoveIn",
    FMSplushasp30MoveInMethod = "FMSplushasp30MoveInMethod",
    FMSplushasp30MoveInReferral = "FMSplushasp30MoveInReferral",
    FMSplushasp30MoveInReferral1 = "FMSplushasp30MoveInReferral1",
    FMSplushasp30MoveInReview = "FMSplushasp30MoveInReview",
    FMSplushasp30MoveOut = "FMSplushasp30MoveOut",
    FMSplushasp30MoveOutMethod = "FMSplushasp30MoveOutMethod",
    FMSplushasp30MoveOutReview = "FMSplushasp30MoveOutReview",
    FMSplushasp30PastDue = "FMSplushasp30PastDue",
    FMSplushasp30PastDueMethod = "FMSplushasp30PastDueMethod",
    FMSplushasp3AbandonedCart = "FMSplushasp3AbandonedCart",
    FMSplushasp3AbandonedCart1 = "FMSplushasp3AbandonedCart1",
    FMSplushasp3AbandonedCart2 = "FMSplushasp3AbandonedCart2",
    FMSplushasp3AbandonedCart2Enabled = "FMSplushasp3AbandonedCart2Enabled",
    FMSplushasp3AbandonedCartMethod = "FMSplushasp3AbandonedCartMethod",
    FMSplushasp3MoveIn = "FMSplushasp3MoveIn",
    FMSplushasp3MoveInMethod = "FMSplushasp3MoveInMethod",
    FMSplushasp3MoveInReferral = "FMSplushasp3MoveInReferral",
    FMSplushasp3MoveInReferral1 = "FMSplushasp3MoveInReferral1",
    FMSplushasp3MoveInReview = "FMSplushasp3MoveInReview",
    FMSplushasp3MoveOut = "FMSplushasp3MoveOut",
    FMSplushasp3MoveOutMethod = "FMSplushasp3MoveOutMethod",
    FMSplushasp3MoveOutReview = "FMSplushasp3MoveOutReview",
    FMSplushasp3PastDue = "FMSplushasp3PastDue",
    FMSplushasp3PastDueMethod = "FMSplushasp3PastDueMethod",
    FMSplushasp45PastDue = "FMSplushasp45PastDue",
    FMSplushasp45PastDueMethod = "FMSplushasp45PastDueMethod",
    FMSplushasp5AbandonedCart = "FMSplushasp5AbandonedCart",
    FMSplushasp5AbandonedCart1 = "FMSplushasp5AbandonedCart1",
    FMSplushasp5AbandonedCart2 = "FMSplushasp5AbandonedCart2",
    FMSplushasp5AbandonedCart2Enabled = "FMSplushasp5AbandonedCart2Enabled",
    FMSplushasp5AbandonedCartMethod = "FMSplushasp5AbandonedCartMethod",
    FMSplushasp5MoveIn = "FMSplushasp5MoveIn",
    FMSplushasp5MoveInMethod = "FMSplushasp5MoveInMethod",
    FMSplushasp5MoveInReferral = "FMSplushasp5MoveInReferral",
    FMSplushasp5MoveInReferral1 = "FMSplushasp5MoveInReferral1",
    FMSplushasp5MoveInReview = "FMSplushasp5MoveInReview",
    FMSplushasp5MoveOut = "FMSplushasp5MoveOut",
    FMSplushasp5MoveOutMethod = "FMSplushasp5MoveOutMethod",
    FMSplushasp5MoveOutReview = "FMSplushasp5MoveOutReview",
    FMSplushasp5PastDue = "FMSplushasp5PastDue",
    FMSplushasp5PastDueMethod = "FMSplushasp5PastDueMethod",
    FMSplushasp7AbandonedCart = "FMSplushasp7AbandonedCart",
    FMSplushasp7AbandonedCart1 = "FMSplushasp7AbandonedCart1",
    FMSplushasp7AbandonedCart2 = "FMSplushasp7AbandonedCart2",
    FMSplushasp7AbandonedCart2Enabled = "FMSplushasp7AbandonedCart2Enabled",
    FMSplushasp7AbandonedCartMethod = "FMSplushasp7AbandonedCartMethod",
    FMSplushasp7MoveIn = "FMSplushasp7MoveIn",
    FMSplushasp7MoveInMethod = "FMSplushasp7MoveInMethod",
    FMSplushasp7MoveInReferral = "FMSplushasp7MoveInReferral",
    FMSplushasp7MoveInReferral1 = "FMSplushasp7MoveInReferral1",
    FMSplushasp7MoveInReview = "FMSplushasp7MoveInReview",
    FMSplushasp7MoveOut = "FMSplushasp7MoveOut",
    FMSplushasp7MoveOutMethod = "FMSplushasp7MoveOutMethod",
    FMSplushasp7MoveOutReview = "FMSplushasp7MoveOutReview",
    FMSplushasp7PastDue = "FMSplushasp7PastDue",
    FMSplushasp7PastDueMethod = "FMSplushasp7PastDueMethod",
    FMSplushasp7UpdateContactInfo = "FMSplushasp7UpdateContactInfo",
    FMSplushasp7UpdateContactInfoMethod = "FMSplushasp7UpdateContactInfoMethod",
    FMSplushasp90MoveIn = "FMSplushasp90MoveIn",
    FMSplushasp90MoveInMethod = "FMSplushasp90MoveInMethod",
    FMSplushasp90MoveInReferral = "FMSplushasp90MoveInReferral",
    FMSplushasp90MoveInReferral1 = "FMSplushasp90MoveInReferral1",
    FMSplushasp90MoveInReview = "FMSplushasp90MoveInReview",
    FMSplusn14PaymentMethodExpiring1 = "FMSplusn14PaymentMethodExpiring1",
    FMSplusn14PaymentMethodExpiring2 = "FMSplusn14PaymentMethodExpiring2",
    FMSplusn14PaymentMethodExpiring2Enabled = "FMSplusn14PaymentMethodExpiring2Enabled",
    FMSplusn14PaymentMethodExpiring3 = "FMSplusn14PaymentMethodExpiring3",
    FMSplusn14PaymentMethodExpiring3Enabled = "FMSplusn14PaymentMethodExpiring3Enabled",
    FMSplusn1PaymentDue1 = "FMSplusn1PaymentDue1",
    FMSplusn1PaymentDue2 = "FMSplusn1PaymentDue2",
    FMSplusn1PaymentDue2Enabled = "FMSplusn1PaymentDue2Enabled",
    FMSplusn1PaymentDue3 = "FMSplusn1PaymentDue3",
    FMSplusn1PaymentDue3Enabled = "FMSplusn1PaymentDue3Enabled",
    FMSplusn1PaymentMethodExpiring1 = "FMSplusn1PaymentMethodExpiring1",
    FMSplusn1PaymentMethodExpiring2 = "FMSplusn1PaymentMethodExpiring2",
    FMSplusn1PaymentMethodExpiring2Enabled = "FMSplusn1PaymentMethodExpiring2Enabled",
    FMSplusn1PaymentMethodExpiring3 = "FMSplusn1PaymentMethodExpiring3",
    FMSplusn1PaymentMethodExpiring3Enabled = "FMSplusn1PaymentMethodExpiring3Enabled",
    FMSplusn2PaymentDue1 = "FMSplusn2PaymentDue1",
    FMSplusn2PaymentDue2 = "FMSplusn2PaymentDue2",
    FMSplusn2PaymentDue2Enabled = "FMSplusn2PaymentDue2Enabled",
    FMSplusn2PaymentDue3 = "FMSplusn2PaymentDue3",
    FMSplusn2PaymentDue3Enabled = "FMSplusn2PaymentDue3Enabled",
    FMSplusn30PaymentMethodExpiring1 = "FMSplusn30PaymentMethodExpiring1",
    FMSplusn30PaymentMethodExpiring2 = "FMSplusn30PaymentMethodExpiring2",
    FMSplusn30PaymentMethodExpiring2Enabled = "FMSplusn30PaymentMethodExpiring2Enabled",
    FMSplusn30PaymentMethodExpiring3 = "FMSplusn30PaymentMethodExpiring3",
    FMSplusn30PaymentMethodExpiring3Enabled = "FMSplusn30PaymentMethodExpiring3Enabled",
    FMSplusn3PaymentDue1 = "FMSplusn3PaymentDue1",
    FMSplusn3PaymentDue2 = "FMSplusn3PaymentDue2",
    FMSplusn3PaymentDue2Enabled = "FMSplusn3PaymentDue2Enabled",
    FMSplusn3PaymentDue3 = "FMSplusn3PaymentDue3",
    FMSplusn3PaymentDue3Enabled = "FMSplusn3PaymentDue3Enabled",
    FMSplusn5PaymentDue1 = "FMSplusn5PaymentDue1",
    FMSplusn5PaymentDue2 = "FMSplusn5PaymentDue2",
    FMSplusn5PaymentDue2Enabled = "FMSplusn5PaymentDue2Enabled",
    FMSplusn5PaymentDue3 = "FMSplusn5PaymentDue3",
    FMSplusn5PaymentDue3Enabled = "FMSplusn5PaymentDue3Enabled",
    FMSplusn7PaymentDue1 = "FMSplusn7PaymentDue1",
    FMSplusn7PaymentDue2 = "FMSplusn7PaymentDue2",
    FMSplusn7PaymentDue2Enabled = "FMSplusn7PaymentDue2Enabled",
    FMSplusn7PaymentDue3 = "FMSplusn7PaymentDue3",
    FMSplusn7PaymentDue3Enabled = "FMSplusn7PaymentDue3Enabled",
    FMSplusn7PaymentMethodExpiring1 = "FMSplusn7PaymentMethodExpiring1",
    FMSplusn7PaymentMethodExpiring2 = "FMSplusn7PaymentMethodExpiring2",
    FMSplusn7PaymentMethodExpiring2Enabled = "FMSplusn7PaymentMethodExpiring2Enabled",
    FMSplusn7PaymentMethodExpiring3 = "FMSplusn7PaymentMethodExpiring3",
    FMSplusn7PaymentMethodExpiring3Enabled = "FMSplusn7PaymentMethodExpiring3Enabled",
    FMSplusp10AbandonedCart2Shortlink = "FMSplusp10AbandonedCart2Shortlink",
    FMSplusp10AbandonedCartEmailEnabled = "FMSplusp10AbandonedCartEmailEnabled",
    FMSplusp10AbandonedCartEmailShortlink = "FMSplusp10AbandonedCartEmailShortlink",
    FMSplusp10AbandonedCartSMSEnabled = "FMSplusp10AbandonedCartSMSEnabled",
    FMSplusp10AbandonedCartSMSShortlink = "FMSplusp10AbandonedCartSMSShortlink",
    FMSplusp10AbandonedCartVoiceEnabled = "FMSplusp10AbandonedCartVoiceEnabled",
    FMSplusp10AbandonedCartVoiceMessage = "FMSplusp10AbandonedCartVoiceMessage",
    FMSplusp10MoveIn1 = "FMSplusp10MoveIn1",
    FMSplusp10MoveIn2 = "FMSplusp10MoveIn2",
    FMSplusp10MoveIn2Enabled = "FMSplusp10MoveIn2Enabled",
    FMSplusp10MoveIn3 = "FMSplusp10MoveIn3",
    FMSplusp10MoveIn3Enabled = "FMSplusp10MoveIn3Enabled",
    FMSplusp10MoveOut1 = "FMSplusp10MoveOut1",
    FMSplusp10MoveOut2 = "FMSplusp10MoveOut2",
    FMSplusp10MoveOut2Enabled = "FMSplusp10MoveOut2Enabled",
    FMSplusp10MoveOut3 = "FMSplusp10MoveOut3",
    FMSplusp10MoveOut3Enabled = "FMSplusp10MoveOut3Enabled",
    FMSplusp10PastDue1 = "FMSplusp10PastDue1",
    FMSplusp10PastDue2 = "FMSplusp10PastDue2",
    FMSplusp10PastDue2Enabled = "FMSplusp10PastDue2Enabled",
    FMSplusp10PastDue2Shortlink = "FMSplusp10PastDue2Shortlink",
    FMSplusp10PastDue3 = "FMSplusp10PastDue3",
    FMSplusp10PastDue3Enabled = "FMSplusp10PastDue3Enabled",
    FMSplusp10PastDueEmailEnabled = "FMSplusp10PastDueEmailEnabled",
    FMSplusp10PastDueEmailShortlink = "FMSplusp10PastDueEmailShortlink",
    FMSplusp10PastDueSMSEnabled = "FMSplusp10PastDueSMSEnabled",
    FMSplusp10PastDueSMSShortlink = "FMSplusp10PastDueSMSShortlink",
    FMSplusp10PastDueVoiceEnabled = "FMSplusp10PastDueVoiceEnabled",
    FMSplusp10PastDueVoiceMessage = "FMSplusp10PastDueVoiceMessage",
    FMSplusp14AbandonedCart2Shortlink = "FMSplusp14AbandonedCart2Shortlink",
    FMSplusp14AbandonedCartEmailEnabled = "FMSplusp14AbandonedCartEmailEnabled",
    FMSplusp14AbandonedCartEmailShortlink = "FMSplusp14AbandonedCartEmailShortlink",
    FMSplusp14AbandonedCartSMSEnabled = "FMSplusp14AbandonedCartSMSEnabled",
    FMSplusp14AbandonedCartSMSShortlink = "FMSplusp14AbandonedCartSMSShortlink",
    FMSplusp14AbandonedCartVoiceEnabled = "FMSplusp14AbandonedCartVoiceEnabled",
    FMSplusp14AbandonedCartVoiceMessage = "FMSplusp14AbandonedCartVoiceMessage",
    FMSplusp14MoveIn1 = "FMSplusp14MoveIn1",
    FMSplusp14MoveIn2 = "FMSplusp14MoveIn2",
    FMSplusp14MoveIn2Enabled = "FMSplusp14MoveIn2Enabled",
    FMSplusp14MoveIn3 = "FMSplusp14MoveIn3",
    FMSplusp14MoveIn3Enabled = "FMSplusp14MoveIn3Enabled",
    FMSplusp14MoveOut1 = "FMSplusp14MoveOut1",
    FMSplusp14MoveOut2 = "FMSplusp14MoveOut2",
    FMSplusp14MoveOut2Enabled = "FMSplusp14MoveOut2Enabled",
    FMSplusp14MoveOut3 = "FMSplusp14MoveOut3",
    FMSplusp14MoveOut3Enabled = "FMSplusp14MoveOut3Enabled",
    FMSplusp14PastDue1 = "FMSplusp14PastDue1",
    FMSplusp14PastDue2 = "FMSplusp14PastDue2",
    FMSplusp14PastDue2Enabled = "FMSplusp14PastDue2Enabled",
    FMSplusp14PastDue2Shortlink = "FMSplusp14PastDue2Shortlink",
    FMSplusp14PastDue3 = "FMSplusp14PastDue3",
    FMSplusp14PastDue3Enabled = "FMSplusp14PastDue3Enabled",
    FMSplusp14PastDueEmailEnabled = "FMSplusp14PastDueEmailEnabled",
    FMSplusp14PastDueEmailShortlink = "FMSplusp14PastDueEmailShortlink",
    FMSplusp14PastDueSMSEnabled = "FMSplusp14PastDueSMSEnabled",
    FMSplusp14PastDueSMSShortlink = "FMSplusp14PastDueSMSShortlink",
    FMSplusp14PastDueVoiceEnabled = "FMSplusp14PastDueVoiceEnabled",
    FMSplusp14PastDueVoiceMessage = "FMSplusp14PastDueVoiceMessage",
    FMSplusp1AbandonedCart2Shortlink = "FMSplusp1AbandonedCart2Shortlink",
    FMSplusp1AbandonedCartEmailEnabled = "FMSplusp1AbandonedCartEmailEnabled",
    FMSplusp1AbandonedCartEmailShortlink = "FMSplusp1AbandonedCartEmailShortlink",
    FMSplusp1AbandonedCartSMSEnabled = "FMSplusp1AbandonedCartSMSEnabled",
    FMSplusp1AbandonedCartSMSShortlink = "FMSplusp1AbandonedCartSMSShortlink",
    FMSplusp1AbandonedCartVoiceEnabled = "FMSplusp1AbandonedCartVoiceEnabled",
    FMSplusp1AbandonedCartVoiceMessage = "FMSplusp1AbandonedCartVoiceMessage",
    FMSplusp1MoveIn1 = "FMSplusp1MoveIn1",
    FMSplusp1MoveIn2 = "FMSplusp1MoveIn2",
    FMSplusp1MoveIn2Enabled = "FMSplusp1MoveIn2Enabled",
    FMSplusp1MoveIn3 = "FMSplusp1MoveIn3",
    FMSplusp1MoveIn3Enabled = "FMSplusp1MoveIn3Enabled",
    FMSplusp1MoveOut1 = "FMSplusp1MoveOut1",
    FMSplusp1MoveOut2 = "FMSplusp1MoveOut2",
    FMSplusp1MoveOut2Enabled = "FMSplusp1MoveOut2Enabled",
    FMSplusp1MoveOut3 = "FMSplusp1MoveOut3",
    FMSplusp1MoveOut3Enabled = "FMSplusp1MoveOut3Enabled",
    FMSplusp1PastDue1 = "FMSplusp1PastDue1",
    FMSplusp1PastDue2 = "FMSplusp1PastDue2",
    FMSplusp1PastDue2Enabled = "FMSplusp1PastDue2Enabled",
    FMSplusp1PastDue2Shortlink = "FMSplusp1PastDue2Shortlink",
    FMSplusp1PastDue3 = "FMSplusp1PastDue3",
    FMSplusp1PastDue3Enabled = "FMSplusp1PastDue3Enabled",
    FMSplusp1PastDueEmailEnabled = "FMSplusp1PastDueEmailEnabled",
    FMSplusp1PastDueEmailShortlink = "FMSplusp1PastDueEmailShortlink",
    FMSplusp1PastDueSMSEnabled = "FMSplusp1PastDueSMSEnabled",
    FMSplusp1PastDueSMSShortlink = "FMSplusp1PastDueSMSShortlink",
    FMSplusp1PastDueVoiceEnabled = "FMSplusp1PastDueVoiceEnabled",
    FMSplusp1PastDueVoiceMessage = "FMSplusp1PastDueVoiceMessage",
    FMSplusp2AbandonedCart2Shortlink = "FMSplusp2AbandonedCart2Shortlink",
    FMSplusp2AbandonedCartEmailEnabled = "FMSplusp2AbandonedCartEmailEnabled",
    FMSplusp2AbandonedCartEmailShortlink = "FMSplusp2AbandonedCartEmailShortlink",
    FMSplusp2AbandonedCartSMSEnabled = "FMSplusp2AbandonedCartSMSEnabled",
    FMSplusp2AbandonedCartSMSShortlink = "FMSplusp2AbandonedCartSMSShortlink",
    FMSplusp2AbandonedCartVoiceEnabled = "FMSplusp2AbandonedCartVoiceEnabled",
    FMSplusp2AbandonedCartVoiceMessage = "FMSplusp2AbandonedCartVoiceMessage",
    FMSplusp2PastDue1 = "FMSplusp2PastDue1",
    FMSplusp2PastDue2 = "FMSplusp2PastDue2",
    FMSplusp2PastDue2Enabled = "FMSplusp2PastDue2Enabled",
    FMSplusp2PastDue2Shortlink = "FMSplusp2PastDue2Shortlink",
    FMSplusp2PastDue3 = "FMSplusp2PastDue3",
    FMSplusp2PastDue3Enabled = "FMSplusp2PastDue3Enabled",
    FMSplusp2PastDueEmailEnabled = "FMSplusp2PastDueEmailEnabled",
    FMSplusp2PastDueEmailShortlink = "FMSplusp2PastDueEmailShortlink",
    FMSplusp2PastDueSMSEnabled = "FMSplusp2PastDueSMSEnabled",
    FMSplusp2PastDueSMSShortlink = "FMSplusp2PastDueSMSShortlink",
    FMSplusp2PastDueVoiceEnabled = "FMSplusp2PastDueVoiceEnabled",
    FMSplusp2PastDueVoiceMessage = "FMSplusp2PastDueVoiceMessage",
    FMSplusp30AbandonedCart2Shortlink = "FMSplusp30AbandonedCart2Shortlink",
    FMSplusp30AbandonedCartEmailEnabled = "FMSplusp30AbandonedCartEmailEnabled",
    FMSplusp30AbandonedCartEmailShortlink = "FMSplusp30AbandonedCartEmailShortlink",
    FMSplusp30AbandonedCartSMSEnabled = "FMSplusp30AbandonedCartSMSEnabled",
    FMSplusp30AbandonedCartSMSShortlink = "FMSplusp30AbandonedCartSMSShortlink",
    FMSplusp30AbandonedCartVoiceEnabled = "FMSplusp30AbandonedCartVoiceEnabled",
    FMSplusp30AbandonedCartVoiceMessage = "FMSplusp30AbandonedCartVoiceMessage",
    FMSplusp30MoveIn1 = "FMSplusp30MoveIn1",
    FMSplusp30MoveIn2 = "FMSplusp30MoveIn2",
    FMSplusp30MoveIn2Enabled = "FMSplusp30MoveIn2Enabled",
    FMSplusp30MoveIn3 = "FMSplusp30MoveIn3",
    FMSplusp30MoveIn3Enabled = "FMSplusp30MoveIn3Enabled",
    FMSplusp30MoveOut1 = "FMSplusp30MoveOut1",
    FMSplusp30MoveOut2 = "FMSplusp30MoveOut2",
    FMSplusp30MoveOut2Enabled = "FMSplusp30MoveOut2Enabled",
    FMSplusp30MoveOut3 = "FMSplusp30MoveOut3",
    FMSplusp30MoveOut3Enabled = "FMSplusp30MoveOut3Enabled",
    FMSplusp30PastDue1 = "FMSplusp30PastDue1",
    FMSplusp30PastDue2 = "FMSplusp30PastDue2",
    FMSplusp30PastDue2Enabled = "FMSplusp30PastDue2Enabled",
    FMSplusp30PastDue2Shortlink = "FMSplusp30PastDue2Shortlink",
    FMSplusp30PastDue3 = "FMSplusp30PastDue3",
    FMSplusp30PastDue3Enabled = "FMSplusp30PastDue3Enabled",
    FMSplusp30PastDueEmailEnabled = "FMSplusp30PastDueEmailEnabled",
    FMSplusp30PastDueEmailShortlink = "FMSplusp30PastDueEmailShortlink",
    FMSplusp30PastDueSMSEnabled = "FMSplusp30PastDueSMSEnabled",
    FMSplusp30PastDueSMSShortlink = "FMSplusp30PastDueSMSShortlink",
    FMSplusp30PastDueVoiceEnabled = "FMSplusp30PastDueVoiceEnabled",
    FMSplusp30PastDueVoiceMessage = "FMSplusp30PastDueVoiceMessage",
    FMSplusp3AbandonedCart2Shortlink = "FMSplusp3AbandonedCart2Shortlink",
    FMSplusp3AbandonedCartEmailEnabled = "FMSplusp3AbandonedCartEmailEnabled",
    FMSplusp3AbandonedCartEmailShortlink = "FMSplusp3AbandonedCartEmailShortlink",
    FMSplusp3AbandonedCartSMSEnabled = "FMSplusp3AbandonedCartSMSEnabled",
    FMSplusp3AbandonedCartSMSShortlink = "FMSplusp3AbandonedCartSMSShortlink",
    FMSplusp3AbandonedCartVoiceEnabled = "FMSplusp3AbandonedCartVoiceEnabled",
    FMSplusp3AbandonedCartVoiceMessage = "FMSplusp3AbandonedCartVoiceMessage",
    FMSplusp3MoveIn1 = "FMSplusp3MoveIn1",
    FMSplusp3MoveIn2 = "FMSplusp3MoveIn2",
    FMSplusp3MoveIn2Enabled = "FMSplusp3MoveIn2Enabled",
    FMSplusp3MoveIn3 = "FMSplusp3MoveIn3",
    FMSplusp3MoveIn3Enabled = "FMSplusp3MoveIn3Enabled",
    FMSplusp3MoveOut1 = "FMSplusp3MoveOut1",
    FMSplusp3MoveOut2 = "FMSplusp3MoveOut2",
    FMSplusp3MoveOut2Enabled = "FMSplusp3MoveOut2Enabled",
    FMSplusp3MoveOut3 = "FMSplusp3MoveOut3",
    FMSplusp3MoveOut3Enabled = "FMSplusp3MoveOut3Enabled",
    FMSplusp3PastDue1 = "FMSplusp3PastDue1",
    FMSplusp3PastDue2 = "FMSplusp3PastDue2",
    FMSplusp3PastDue2Enabled = "FMSplusp3PastDue2Enabled",
    FMSplusp3PastDue2Shortlink = "FMSplusp3PastDue2Shortlink",
    FMSplusp3PastDue3 = "FMSplusp3PastDue3",
    FMSplusp3PastDue3Enabled = "FMSplusp3PastDue3Enabled",
    FMSplusp3PastDueEmailEnabled = "FMSplusp3PastDueEmailEnabled",
    FMSplusp3PastDueEmailShortlink = "FMSplusp3PastDueEmailShortlink",
    FMSplusp3PastDueSMSEnabled = "FMSplusp3PastDueSMSEnabled",
    FMSplusp3PastDueSMSShortlink = "FMSplusp3PastDueSMSShortlink",
    FMSplusp3PastDueVoiceEnabled = "FMSplusp3PastDueVoiceEnabled",
    FMSplusp3PastDueVoiceMessage = "FMSplusp3PastDueVoiceMessage",
    FMSplusp45PastDue1 = "FMSplusp45PastDue1",
    FMSplusp45PastDue2 = "FMSplusp45PastDue2",
    FMSplusp45PastDue2Enabled = "FMSplusp45PastDue2Enabled",
    FMSplusp45PastDue2Shortlink = "FMSplusp45PastDue2Shortlink",
    FMSplusp45PastDue3 = "FMSplusp45PastDue3",
    FMSplusp45PastDue3Enabled = "FMSplusp45PastDue3Enabled",
    FMSplusp45PastDueEmailEnabled = "FMSplusp45PastDueEmailEnabled",
    FMSplusp45PastDueEmailShortlink = "FMSplusp45PastDueEmailShortlink",
    FMSplusp45PastDueSMSEnabled = "FMSplusp45PastDueSMSEnabled",
    FMSplusp45PastDueSMSShortlink = "FMSplusp45PastDueSMSShortlink",
    FMSplusp45PastDueVoiceEnabled = "FMSplusp45PastDueVoiceEnabled",
    FMSplusp45PastDueVoiceMessage = "FMSplusp45PastDueVoiceMessage",
    FMSplusp5AbandonedCart2Shortlink = "FMSplusp5AbandonedCart2Shortlink",
    FMSplusp5AbandonedCartEmailEnabled = "FMSplusp5AbandonedCartEmailEnabled",
    FMSplusp5AbandonedCartEmailShortlink = "FMSplusp5AbandonedCartEmailShortlink",
    FMSplusp5AbandonedCartSMSEnabled = "FMSplusp5AbandonedCartSMSEnabled",
    FMSplusp5AbandonedCartSMSShortlink = "FMSplusp5AbandonedCartSMSShortlink",
    FMSplusp5AbandonedCartVoiceEnabled = "FMSplusp5AbandonedCartVoiceEnabled",
    FMSplusp5AbandonedCartVoiceMessage = "FMSplusp5AbandonedCartVoiceMessage",
    FMSplusp5MoveIn1 = "FMSplusp5MoveIn1",
    FMSplusp5MoveIn2 = "FMSplusp5MoveIn2",
    FMSplusp5MoveIn2Enabled = "FMSplusp5MoveIn2Enabled",
    FMSplusp5MoveIn3 = "FMSplusp5MoveIn3",
    FMSplusp5MoveIn3Enabled = "FMSplusp5MoveIn3Enabled",
    FMSplusp5MoveOut1 = "FMSplusp5MoveOut1",
    FMSplusp5MoveOut2 = "FMSplusp5MoveOut2",
    FMSplusp5MoveOut2Enabled = "FMSplusp5MoveOut2Enabled",
    FMSplusp5MoveOut3 = "FMSplusp5MoveOut3",
    FMSplusp5MoveOut3Enabled = "FMSplusp5MoveOut3Enabled",
    FMSplusp5PastDue1 = "FMSplusp5PastDue1",
    FMSplusp5PastDue2 = "FMSplusp5PastDue2",
    FMSplusp5PastDue2Enabled = "FMSplusp5PastDue2Enabled",
    FMSplusp5PastDue2Shortlink = "FMSplusp5PastDue2Shortlink",
    FMSplusp5PastDue3 = "FMSplusp5PastDue3",
    FMSplusp5PastDue3Enabled = "FMSplusp5PastDue3Enabled",
    FMSplusp5PastDueEmailEnabled = "FMSplusp5PastDueEmailEnabled",
    FMSplusp5PastDueEmailShortlink = "FMSplusp5PastDueEmailShortlink",
    FMSplusp5PastDueSMSEnabled = "FMSplusp5PastDueSMSEnabled",
    FMSplusp5PastDueSMSShortlink = "FMSplusp5PastDueSMSShortlink",
    FMSplusp5PastDueVoiceEnabled = "FMSplusp5PastDueVoiceEnabled",
    FMSplusp5PastDueVoiceMessage = "FMSplusp5PastDueVoiceMessage",
    FMSplusp7AbandonedCart2Shortlink = "FMSplusp7AbandonedCart2Shortlink",
    FMSplusp7AbandonedCartEmailEnabled = "FMSplusp7AbandonedCartEmailEnabled",
    FMSplusp7AbandonedCartEmailShortlink = "FMSplusp7AbandonedCartEmailShortlink",
    FMSplusp7AbandonedCartSMSEnabled = "FMSplusp7AbandonedCartSMSEnabled",
    FMSplusp7AbandonedCartSMSShortlink = "FMSplusp7AbandonedCartSMSShortlink",
    FMSplusp7AbandonedCartVoiceEnabled = "FMSplusp7AbandonedCartVoiceEnabled",
    FMSplusp7AbandonedCartVoiceMessage = "FMSplusp7AbandonedCartVoiceMessage",
    FMSplusp7MoveIn1 = "FMSplusp7MoveIn1",
    FMSplusp7MoveIn2 = "FMSplusp7MoveIn2",
    FMSplusp7MoveIn2Enabled = "FMSplusp7MoveIn2Enabled",
    FMSplusp7MoveIn3 = "FMSplusp7MoveIn3",
    FMSplusp7MoveIn3Enabled = "FMSplusp7MoveIn3Enabled",
    FMSplusp7MoveOut1 = "FMSplusp7MoveOut1",
    FMSplusp7MoveOut2 = "FMSplusp7MoveOut2",
    FMSplusp7MoveOut2Enabled = "FMSplusp7MoveOut2Enabled",
    FMSplusp7MoveOut3 = "FMSplusp7MoveOut3",
    FMSplusp7MoveOut3Enabled = "FMSplusp7MoveOut3Enabled",
    FMSplusp7PastDue1 = "FMSplusp7PastDue1",
    FMSplusp7PastDue2 = "FMSplusp7PastDue2",
    FMSplusp7PastDue2Enabled = "FMSplusp7PastDue2Enabled",
    FMSplusp7PastDue2Shortlink = "FMSplusp7PastDue2Shortlink",
    FMSplusp7PastDue3 = "FMSplusp7PastDue3",
    FMSplusp7PastDue3Enabled = "FMSplusp7PastDue3Enabled",
    FMSplusp7PastDueEmailEnabled = "FMSplusp7PastDueEmailEnabled",
    FMSplusp7PastDueEmailShortlink = "FMSplusp7PastDueEmailShortlink",
    FMSplusp7PastDueSMSEnabled = "FMSplusp7PastDueSMSEnabled",
    FMSplusp7PastDueSMSShortlink = "FMSplusp7PastDueSMSShortlink",
    FMSplusp7PastDueVoiceEnabled = "FMSplusp7PastDueVoiceEnabled",
    FMSplusp7PastDueVoiceMessage = "FMSplusp7PastDueVoiceMessage",
    FMSplusp7UpdateContactInfo1 = "FMSplusp7UpdateContactInfo1",
    FMSplusp7UpdateContactInfo2 = "FMSplusp7UpdateContactInfo2",
    FMSplusp7UpdateContactInfo2Enabled = "FMSplusp7UpdateContactInfo2Enabled",
    FMSplusp7UpdateContactInfo3 = "FMSplusp7UpdateContactInfo3",
    FMSplusp7UpdateContactInfo3Enabled = "FMSplusp7UpdateContactInfo3Enabled",
    FMSplusp90MoveIn1 = "FMSplusp90MoveIn1",
    FMSplusp90MoveIn2 = "FMSplusp90MoveIn2",
    FMSplusp90MoveIn2Enabled = "FMSplusp90MoveIn2Enabled",
    FMSplusPastDueShortlinksEnabled = "FMSplusPastDueShortlinksEnabled",
    FMSplusPromoter1Shortlink = "FMSplusPromoter1Shortlink",
    FMSplusPromoterShortlinkEnabled = "FMSplusPromoterShortlinkEnabled",
    FMSplusPromoterSMSShortlink = "FMSplusPromoterSMSShortlink",
    FMSplusRecurringPastDue1 = "FMSplusRecurringPastDue1",
    FMSplusRecurringPastDue2 = "FMSplusRecurringPastDue2",
    FMSplusRecurringPastDue2Enabled = "FMSplusRecurringPastDue2Enabled",
    FMSplusRecurringPastDue2Shortlink = "FMSplusRecurringPastDue2Shortlink",
    FMSplusRecurringPastDueChannelArray = "FMSplusRecurringPastDueChannelArray",
    FMSplusRecurringPastDueEmailEnabled = "FMSplusRecurringPastDueEmailEnabled",
    FMSplusRecurringPastDueEmailShortlink = "FMSplusRecurringPastDueEmailShortlink",
    FMSplusRecurringPastDueSMSEnabled = "FMSplusRecurringPastDueSMSEnabled",
    FMSplusRecurringPastDueSMSShortlink = "FMSplusRecurringPastDueSMSShortlink",
    FMSplusRecurringPastDueVoiceEnabled = "FMSplusRecurringPastDueVoiceEnabled",
    FMSplusRecurringPastDueVoiceMessage = "FMSplusRecurringPastDueVoiceMessage",
    FMSplusReviewRatingType = "FMSplusReviewRatingType",
    FMSReviewDetractor1 = "FMSReviewDetractor1",
    FMSReviewDetractor2 = "FMSReviewDetractor2",
    FMSReviewDetractor2Enabled = "FMSReviewDetractor2Enabled",
    FMSReviewDetractor3 = "FMSReviewDetractor3",
    FMSReviewDetractor3Enabled = "FMSReviewDetractor3Enabled",
    FMSReviewPassive1 = "FMSReviewPassive1",
    FMSReviewPassive2 = "FMSReviewPassive2",
    FMSReviewPassive2Enabled = "FMSReviewPassive2Enabled",
    FMSReviewPassive3 = "FMSReviewPassive3",
    FMSReviewPassive3Enabled = "FMSReviewPassive3Enabled",
    FMSReviewPromoter1 = "FMSReviewPromoter1",
    FMSReviewPromoter2 = "FMSReviewPromoter2",
    FMSReviewPromoter2Enabled = "FMSReviewPromoter2Enabled",
    FMSReviewPromoter3 = "FMSReviewPromoter3",
    FMSReviewPromoter3Enabled = "FMSReviewPromoter3Enabled",
    FMSReviewStart1 = "FMSReviewStart1",
    FMSReviewStart2 = "FMSReviewStart2",
    FMSReviewStart2Enabled = "FMSReviewStart2Enabled",
    FMSSyncEnabled = "FMSSyncEnabled",
    FMSType = "FMSType",
    FMSUnitNumberChannel = "FMSUnitNumberChannel",
    FMSUnitNumberChannelSMSMessage = "FMSUnitNumberChannelSMSMessage",
    FMSUnits = "FMSUnits",
    GoLocalFID = "GoLocalFID",
    GoogleAccountAndLocationName = "GoogleAccountAndLocationName",
    GoogleAppId = "GoogleAppId",
    GoogleReviewEmailReceiptList = "GoogleReviewEmailReceiptList",
    GoogleReviewRatingTrigger = "GoogleReviewRatingTrigger",
    GoogleReviewsAutoReplyEnabled = "GoogleReviewsAutoReplyEnabled",
    GoogleReviewsAutoReplyMinRating = "GoogleReviewsAutoReplyMinRating",
    GoogleReviewsSyncEnabled = "GoogleReviewsSyncEnabled",
    GoogleReviewURL = "GoogleReviewURL",
    GSAnalyticsStatus = "GSAnalyticsStatus",
    GSAutomatedTextsStatus = "GSAutomatedTextsStatus",
    GSDesignEmbedStatus = "GSDesignEmbedStatus",
    GSFMSConnectStatus = "GSFMSConnectStatus",
    GSGettingStartedCompleted = "GSGettingStartedCompleted",
    GSGoogleChatStatus = "GSGoogleChatStatus",
    GSGoogleReviewsStatus = "GSGoogleReviewsStatus",
    GSInviteAgentsStatus = "GSInviteAgentsStatus",
    GSKickOffMilestoneCompleted = "GSKickOffMilestoneCompleted",
    GSLaunchStatus = "GSLaunchStatus",
    GSMilestone1Completed = "GSMilestone1Completed",
    GSMilestone2Completed = "GSMilestone2Completed",
    GSMonitorChatsStatus = "GSMonitorChatsStatus",
    GSMyStorageStatus = "GSMyStorageStatus",
    GSPostLaunchCompleted = "GSPostLaunchCompleted",
    GSStoreFinderStatus = "GSStoreFinderStatus",
    Has24HourAccess = "Has24HourAccess",
    HasAbandonedCartsReadyToSend = "HasAbandonedCartsReadyToSend",
    HasAboutURL = "HasAboutURL",
    HasAccountBalanceIntegration = "HasAccountBalanceIntegration",
    HasAccountLoginPage = "HasAccountLoginPage",
    HasAccountNumberIntegration = "HasAccountNumberIntegration",
    HasAfterHoursAccess = "HasAfterHoursAccess",
    HasAfterNavigate = "HasAfterNavigate",
    HasAfterNavigateMobileApp = "HasAfterNavigateMobileApp",
    HasAppointments = "HasAppointments",
    HasAuctions = "HasAuctions",
    HasBoatStorage = "HasBoatStorage",
    HasBotInitiatedEscalationsLowConfidenceCollectProfile = "HasBotInitiatedEscalationsLowConfidenceCollectProfile",
    HasBotInitiatedEscalationsSalesCollectProfile = "HasBotInitiatedEscalationsSalesCollectProfile",
    HasBotInitiatedEscalationsServiceCollectProfile = "HasBotInitiatedEscalationsServiceCollectProfile",
    HasBusinessStorage = "HasBusinessStorage",
    HasCareerURL = "HasCareerURL",
    HasChangeDueDate = "HasChangeDueDate",
    HasClimateControlledUnits = "HasClimateControlledUnits",
    HasCompletedQuickStart = "HasCompletedQuickStart",
    HasConferenceRoomnceRoom = "HasConferenceRoomnceRoom",
    HasCoveredVehicleStorage = "HasCoveredVehicleStorage",
    HasCreateLeadForMovingTrucks = "HasCreateLeadForMovingTrucks",
    HasCronAbandonedCarts = "HasCronAbandonedCarts",
    HasCronMoveIn = "HasCronMoveIn",
    HasCronMoveOut = "HasCronMoveOut",
    HasCronPastDuePayment = "HasCronPastDuePayment",
    HasCronPaymentMethodExpired = "HasCronPaymentMethodExpired",
    HasCronPaymentSuccess = "HasCronPaymentSuccess",
    HasCronUpcomingPayment = "HasCronUpcomingPayment",
    HasCronUpdateContactInfo = "HasCronUpdateContactInfo",
    HasCustomCTAMessage = "HasCustomCTAMessage",
    HasDaVinciCodeIntegration = "HasDaVinciCodeIntegration",
    HasDeliveriesAccepted = "HasDeliveriesAccepted",
    HasDiscountCustom = "HasDiscountCustom",
    HasDiscountIntroductory = "HasDiscountIntroductory",
    HasDiscountLongTerm = "HasDiscountLongTerm",
    HasDiscountMilitary = "HasDiscountMilitary",
    HasDiscountSenior = "HasDiscountSenior",
    HasDiscountStudent = "HasDiscountStudent",
    HasDollies = "HasDollies",
    HasDriveUpUnits = "HasDriveUpUnits",
    HasDumpStation = "HasDumpStation",
    HasDumpsters = "HasDumpsters",
    HasElectricityInUnit = "HasElectricityInUnit",
    HasElevators = "HasElevators",
    HasFMS = "HasFMS",
    HasFMSPlus = "HasFMSPlus",
    HasFMSPlusAbandonedCartNotes = "HasFMSPlusAbandonedCartNotes",
    HasFMSPlusMoveInNotes = "HasFMSPlusMoveInNotes",
    HasFMSPlusMoveOutNotes = "HasFMSPlusMoveOutNotes",
    HasFMSPlusPastDueNotes = "HasFMSPlusPastDueNotes",
    HasFranchise = "HasFranchise",
    HasGateCodeIntegration = "HasGateCodeIntegration",
    HasGoogleReviewIntegration = "HasGoogleReviewIntegration",
    HasHeatedUnitsts = "HasHeatedUnitsts",
    HasHumidityControlledUnits = "HasHumidityControlledUnits",
    HasIndoorVehicleStorage = "HasIndoorVehicleStorage",
    HasInsuranceWebsiteURL = "HasInsuranceWebsiteURL",
    HasInventoryCarousel = "HasInventoryCarousel",
    HasLanguagePicker = "HasLanguagePicker",
    HasLiveChat = "HasLiveChat",
    HasLockers = "HasLockers",
    HasMobileApp = "HasMobileApp",
    HasMobileApp2Enabled = "HasMobileApp2Enabled",
    HasMovingServices = "HasMovingServices",
    HasMovingTrucks = "HasMovingTrucks",
    HasNotary = "HasNotary",
    HasOfficeSpace = "HasOfficeSpace",
    HasOnSiteManager = "HasOnSiteManager",
    HasOutdoorVehicleStorage = "HasOutdoorVehicleStorage",
    HasPackingSupplies = "HasPackingSupplies",
    HasPadlocks = "HasPadlocks",
    HasPastDueSpotPaymentPages = "HasPastDueSpotPaymentPages",
    HasPayBillSpotPaymentPages = "HasPayBillSpotPaymentPages",
    HasPayByPhone = "HasPayByPhone",
    HasPayOnlineURL = "HasPayOnlineURL",
    HasPOMailbox = "HasPOMailbox",
    HasPortableUnits = "HasPortableUnits",
    HasPreferredContactMethod = "HasPreferredContactMethod",
    HasPrivacyPolicyURL = "HasPrivacyPolicyURL",
    HasProfileSettingCancelCollectProfile = "HasProfileSettingCancelCollectProfile",
    HasProfileSettingShoppingCollectProfile = "HasProfileSettingShoppingCollectProfile",
    HasPropane = "HasPropane",
    HasRecycleProgram = "HasRecycleProgram",
    HasReferralProgram = "HasReferralProgram",
    HasReviewManager = "HasReviewManager",
    HasRVParking = "HasRVParking",
    HasRVParkingCovered = "HasRVParkingCovered",
    HasRVParkingEnclosed = "HasRVParkingEnclosed",
    HasSegmentEmailReceiptLists = "HasSegmentEmailReceiptLists",
    HasShowAllStores = "HasShowAllStores",
    HasShredProgram = "HasShredProgram",
    HasSingleLocation = "HasSingleLocation",
    HasSizeGuideURL = "HasSizeGuideURL",
    HasSmallVehicleStorage = "HasSmallVehicleStorage",
    HasSMSCampaigns = "HasSMSCampaigns",
    HasSwivlCRM = "HasSwivlCRM",
    HasTrailerStorage = "HasTrailerStorage",
    HasUnitNumberIntegration = "HasUnitNumberIntegration",
    HasValueBasedPricing = "HasValueBasedPricing",
    HasVehicleStorage = "HasVehicleStorage",
    HasVideoSurveillanceveillance = "HasVideoSurveillanceveillance",
    HasWineStorage = "HasWineStorage",
    HubspotAppId = "HubspotAppId",
    HumidityControlHighValue = "HumidityControlHighValue",
    HumidityControlLowValue = "HumidityControlLowValue",
    InformInactive1 = "InformInactive1",
    InformInactive2 = "InformInactive2",
    InformInactive2Enabled = "InformInactive2Enabled",
    InformPastDue1 = "InformPastDue1",
    InformPastDue2 = "InformPastDue2",
    InformPastDue2Enabled = "InformPastDue2Enabled",
    InsuranceDisplayName = "InsuranceDisplayName",
    InsuranceURL = "InsuranceURL",
    LanguagePickerMessage = "LanguagePickerMessage",
    LeadEnableDuplicates = "LeadEnableDuplicates",
    LeadUnitId = "LeadUnitId",
    LeaseAdminFeeAmount = "LeaseAdminFeeAmount",
    LeaseCancellation1 = "LeaseCancellation1",
    LeaseCancellation2 = "LeaseCancellation2",
    LeaseCancellation3 = "LeaseCancellation3",
    LeaseCancellation3Enabled = "LeaseCancellation3Enabled",
    LeaseClaim1 = "LeaseClaim1",
    LeaseClaim2 = "LeaseClaim2",
    LeaseClaim2Enabled = "LeaseClaim2Enabled",
    LeaseContractLengths1 = "LeaseContractLengths1",
    LeaseContractLengths2 = "LeaseContractLengths2",
    LeaseContractLengths3 = "LeaseContractLengths3",
    LeaseContractLengths3Enabled = "LeaseContractLengths3Enabled",
    LeaseContractLengths4 = "LeaseContractLengths4",
    LeaseContractLengths4Enabled = "LeaseContractLengths4Enabled",
    LeaseCovid = "LeaseCovid",
    LeaseCutLocks = "LeaseCutLocks",
    LeaseFacilityAccess1 = "LeaseFacilityAccess1",
    LeaseFacilityAccess2 = "LeaseFacilityAccess2",
    LeaseHoldUnit1 = "LeaseHoldUnit1",
    LeaseHoldUnit2 = "LeaseHoldUnit2",
    LeaseHoldUnit2Enabled = "LeaseHoldUnit2Enabled",
    LeaseInsurance1 = "LeaseInsurance1",
    LeaseInsurance2 = "LeaseInsurance2",
    LeaseInsurance3 = "LeaseInsurance3",
    LeaseLiveInUnit1 = "LeaseLiveInUnit1",
    LeaseLiveInUnit2 = "LeaseLiveInUnit2",
    LeaseLiveInUnit2Enabled = "LeaseLiveInUnit2Enabled",
    LeaseMoveOutPolicy1 = "LeaseMoveOutPolicy1",
    LeaseMoveOutPolicy2 = "LeaseMoveOutPolicy2",
    LeaseMoveOutPolicy3 = "LeaseMoveOutPolicy3",
    LeaseMoveOutPolicy3Enabled = "LeaseMoveOutPolicy3Enabled",
    LeaseOverlock1 = "LeaseOverlock1",
    LeaseOverlock2 = "LeaseOverlock2",
    LeaseOverlock3 = "LeaseOverlock3",
    LeaseOverlock3Enabled = "LeaseOverlock3Enabled",
    LeasePricing1 = "LeasePricing1",
    LeasePricing2 = "LeasePricing2",
    LeasePricing2Enabled = "LeasePricing2Enabled",
    LeasePricing3 = "LeasePricing3",
    LeasePricing3Enabled = "LeasePricing3Enabled",
    LeaseProrate1 = "LeaseProrate1",
    LeaseProrate2 = "LeaseProrate2",
    LeaseProrate2Enabled = "LeaseProrate2Enabled",
    LeaseRefunds1 = "LeaseRefunds1",
    LeaseRefunds2 = "LeaseRefunds2",
    LeaseRefunds2Enabled = "LeaseRefunds2Enabled",
    LeaseStorableItems1 = "LeaseStorableItems1",
    LeaseStorableItems2 = "LeaseStorableItems2",
    LeaseStorableItems2Enabled = "LeaseStorableItems2Enabled",
    LeaseStorableItems3 = "LeaseStorableItems3",
    LeaseStorableItems3Enabled = "LeaseStorableItems3Enabled",
    LeaseUnitTransfer1 = "LeaseUnitTransfer1",
    LeaseUnitTransfer2 = "LeaseUnitTransfer2",
    LeaseUnitTransfer2Enabled = "LeaseUnitTransfer2Enabled",
    LeaseWorkIn1 = "LeaseWorkIn1",
    LeaseWorkIn2 = "LeaseWorkIn2",
    LeaseWorkIn2Enabled = "LeaseWorkIn2Enabled",
    LiveChatFirstCollectProfile = "LiveChatFirstCollectProfile",
    LiveChatNAASales1 = "LiveChatNAASales1",
    LiveChatNAASales2 = "LiveChatNAASales2",
    LiveChatNAASales2Enabled = "LiveChatNAASales2Enabled",
    LiveChatNAAService1 = "LiveChatNAAService1",
    LiveChatNAAService2 = "LiveChatNAAService2",
    LiveChatNAAService2Enabled = "LiveChatNAAService2Enabled",
    LLMAccessAccountInactive = "LLMAccessAccountInactive",
    LLMAccessAccountPastDue = "LLMAccessAccountPastDue",
    LLMAccessAfterHours = "LLMAccessAfterHours",
    LLMAccessGateCode = "LLMAccessGateCode",
    LLMAccessKey = "LLMAccessKey",
    LLMAccessPadlock = "LLMAccessPadlock",
    LLMAccessUnitNumber = "LLMAccessUnitNumber",
    LLMAccountAccountBalance = "LLMAccountAccountBalance",
    LLMAccountAccountNumber = "LLMAccountAccountNumber",
    LLMAccountAutopay = "LLMAccountAutopay",
    LLMAccountBillingDispute = "LLMAccountBillingDispute",
    LLMAccountCancelService = "LLMAccountCancelService",
    LLMAccountChangeDueDate = "LLMAccountChangeDueDate",
    LLMAccountCreateLogin = "LLMAccountCreateLogin",
    LLMAccountCreditDebit = "LLMAccountCreditDebit",
    LLMAccountForgotUsername = "LLMAccountForgotUsername",
    LLMAccountGetLease = "LLMAccountGetLease",
    LLMAccountGracePeriod = "LLMAccountGracePeriod",
    LLMAccountHoldUnit = "LLMAccountHoldUnit",
    LLMAccountManageInsurance = "LLMAccountManageInsurance",
    LLMAccountMultipleAccounts = "LLMAccountMultipleAccounts",
    LLMAccountPartialPayment = "LLMAccountPartialPayment",
    LLMAccountPastDue = "LLMAccountPastDue",
    LLMAccountPayBill = "LLMAccountPayBill",
    LLMAccountPaymentExtension = "LLMAccountPaymentExtension",
    LLMAccountPaymentHistory = "LLMAccountPaymentHistory",
    LLMAccountPaymentIssue = "LLMAccountPaymentIssue",
    LLMAccountReservations = "LLMAccountReservations",
    LLMAccountResetPassword = "LLMAccountResetPassword",
    LLMAccountUnitSize = "LLMAccountUnitSize",
    LLMAccountUpdateBillingInfo = "LLMAccountUpdateBillingInfo",
    LLMAccountUpdateContactInfo = "LLMAccountUpdateContactInfo",
    LLMAgentAddlInstrCollections = "LLMAgentAddlInstrCollections",
    LLMAgentInstructionsAutopay = "LLMAgentInstructionsAutopay",
    LLMAgentInstructionsMakeAPayment = "LLMAgentInstructionsMakeAPayment",
    LLMAICustomerSupportRep = "LLMAICustomerSupportRep",
    LLMAIStorageConsultant = "LLMAIStorageConsultant",
    LLMFeatureAuction = "LLMFeatureAuction",
    LLMFeatureCeiling = "LLMFeatureCeiling",
    LLMFeatureClimateControl = "LLMFeatureClimateControl",
    LLMFeatureCoveredVehicle = "LLMFeatureCoveredVehicle",
    LLMFeatureDriveUp = "LLMFeatureDriveUp",
    LLMFeatureLights = "LLMFeatureLights",
    LLMFeatureMaintenancePest = "LLMFeatureMaintenancePest",
    LLMFeatureMobileApp = "LLMFeatureMobileApp",
    LLMFeatureMovingServices = "LLMFeatureMovingServices",
    LLMFeatureOutdoorParking = "LLMFeatureOutdoorParking",
    LLMFeaturePropane = "LLMFeaturePropane",
    LLMFeatureRVCovered = "LLMFeatureRVCovered",
    LLMFeatureRVEnclosed = "LLMFeatureRVEnclosed",
    LLMFeatureSecurity = "LLMFeatureSecurity",
    LLMFeatureWine = "LLMFeatureWine",
    LLMFeatureWonAuction = "LLMFeatureWonAuction",
    LLMHasABTestAgents = "LLMHasABTestAgents",
    LLMInventoryBoatStorage = "LLMInventoryBoatStorage",
    LLMInventoryIndoorVehicleStorage = "LLMInventoryIndoorVehicleStorage",
    LLMInventoryPOMailbox = "LLMInventoryPOMailbox",
    LLMInventoryRVParking = "LLMInventoryRVParking",
    LLMInventoryVehicleStorage = "LLMInventoryVehicleStorage",
    LLMisAccess = "LLMisAccess",
    LLMisAccountManagement = "LLMisAccountManagement",
    LLMisFeatures = "LLMisFeatures",
    LLMisInventory = "LLMisInventory",
    LLMisIssueResolution = "LLMisIssueResolution",
    LLMisLease = "LLMisLease",
    LLMisPricing = "LLMisPricing",
    LLMisSizing = "LLMisSizing",
    LLMisStoreSpecific = "LLMisStoreSpecific",
    LLMIssueBilling = "LLMIssueBilling",
    LLMIssueDamagedItems = "LLMIssueDamagedItems",
    LLMIssueEmergency = "LLMIssueEmergency",
    LLMIssueGetOut = "LLMIssueGetOut",
    LLMIssueLostKey = "LLMIssueLostKey",
    LLMIssueTheft = "LLMIssueTheft",
    LLMIssueWeb = "LLMIssueWeb",
    LLMisSuggestingPostalCode = "LLMisSuggestingPostalCode",
    LLMisUnhandled = "LLMisUnhandled",
    LLMLeaseCancellation = "LLMLeaseCancellation",
    LLMLeaseClaim = "LLMLeaseClaim",
    LLMLeaseContractLengths = "LLMLeaseContractLengths",
    LLMLeaseCovid = "LLMLeaseCovid",
    LLMLeaseCutLocks = "LLMLeaseCutLocks",
    LLMLeaseFacilityAccess = "LLMLeaseFacilityAccess",
    LLMLeaseInsurance = "LLMLeaseInsurance",
    LLMLeaseLiveInUnit = "LLMLeaseLiveInUnit",
    LLMLeaseMoveOutPolicy = "LLMLeaseMoveOutPolicy",
    LLMLeaseOverlock = "LLMLeaseOverlock",
    LLMLeasePricing = "LLMLeasePricing",
    LLMLeaseProrate = "LLMLeaseProrate",
    LLMLeaseRefunds = "LLMLeaseRefunds",
    LLMLeaseStorableItems = "LLMLeaseStorableItems",
    LLMLeaseUnitTransfer = "LLMLeaseUnitTransfer",
    LLMLeaseWorkInUnit = "LLMLeaseWorkInUnit",
    LLMMoveDollies = "LLMMoveDollies",
    LLMMoveMovingTruck = "LLMMoveMovingTruck",
    LLMMoveSupplies = "LLMMoveSupplies",
    LLMMoveTour = "LLMMoveTour",
    LLMMoveVehicleStorageGuidelines = "LLMMoveVehicleStorageGuidelines",
    LLMPersonality = "LLMPersonality",
    LLMPricingAdminFee = "LLMPricingAdminFee",
    LLMPricingCreditCardFee = "LLMPricingCreditCardFee",
    LLMPricingInsurance = "LLMPricingInsurance",
    LLMPricingLateFee = "LLMPricingLateFee",
    LLMPricingOvercharged = "LLMPricingOvercharged",
    LLMPricingRateIncrease = "LLMPricingRateIncrease",
    LLMPricingReferral = "LLMPricingReferral",
    LLMPricingVBP = "LLMPricingVBP",
    LLMPricingWebRate = "LLMPricingWebRate",
    LLMPromptEnvironmentWebPotential = "LLMPromptEnvironmentWebPotential",
    LLMPromptHelpMeChooseAUnit = "LLMPromptHelpMeChooseAUnit",
    LLMPromptPersonality = "LLMPromptPersonality",
    LLMPromptTone = "LLMPromptTone",
    LLMPurchaseIdentification = "LLMPurchaseIdentification",
    LLMPurchaseMonthly = "LLMPurchaseMonthly",
    LLMPurchaseOptions = "LLMPurchaseOptions",
    LLMPurchasePayOnline = "LLMPurchasePayOnline",
    LLMTone = "LLMTone",
    LLMVoiceSalesAgentEnabled = "LLMVoiceSalesAgentEnabled",
    LLMVoiceSupportAgentEnabled = "LLMVoiceSupportAgentEnabled",
    LoadingAreaType = "LoadingAreaType",
    LocationNumber = "LocationNumber",
    LockTypes = "LockTypes",
    MandrillAppId = "MandrillAppId",
    MapURL = "MapURL",
    MobileApp1 = "MobileApp1",
    MobileApp2 = "MobileApp2",
    MobileAppDownloadURL = "MobileAppDownloadURL",
    MoveDolly1 = "MoveDolly1",
    MoveDolly2 = "MoveDolly2",
    MoveDolly2Enabled = "MoveDolly2Enabled",
    MoveKeyAccessLock1 = "MoveKeyAccessLock1",
    MoveKeyAccessLock2 = "MoveKeyAccessLock2",
    MoveMovingSupplies1 = "MoveMovingSupplies1",
    MoveMovingSupplies2 = "MoveMovingSupplies2",
    MoveMovingSupplies2Enabled = "MoveMovingSupplies2Enabled",
    MoveMovingTruck1 = "MoveMovingTruck1",
    MoveMovingTruck2 = "MoveMovingTruck2",
    MoveMovingTruck2Enabled = "MoveMovingTruck2Enabled",
    MoveTour1 = "MoveTour1",
    MovingServicesURL = "MovingServicesURL",
    NAASales1 = "NAASales1",
    NAAService1 = "NAAService1",
    Name = "Name",
    NavigateToHolder = "NavigateToHolder",
    OfficeHours = "OfficeHours",
    OnboardingDocument = "OnboardingDocument",
    OnboardingGoogleSheet = "OnboardingGoogleSheet",
    OnboardingReadyToSave = "OnboardingReadyToSave",
    OnlyShowUnitDimensions = "OnlyShowUnitDimensions",
    OutdoorParking1 = "OutdoorParking1",
    OutdoorParking2 = "OutdoorParking2",
    OutdoorParking2Enabled = "OutdoorParking2Enabled",
    OutdoorVehicleStorage1 = "OutdoorVehicleStorage1",
    OutsideBusiness1 = "OutsideBusiness1",
    OutsideBusiness2 = "OutsideBusiness2",
    OutsideBusiness2Enabled = "OutsideBusiness2Enabled",
    OutsideBusinessConfirm1 = "OutsideBusinessConfirm1",
    PackingSuppliesURL = "PackingSuppliesURL",
    ParkingType = "ParkingType",
    PayBillSpotPaymentMessage = "PayBillSpotPaymentMessage",
    PayByPhoneNumber = "PayByPhoneNumber",
    PaymentOptions = "PaymentOptions",
    PaymentURL = "PaymentURL",
    PayOnlineURL = "PayOnlineURL",
    Persona = "Persona",
    Phone = "Phone",
    POMailbox1 = "POMailbox1",
    PortableUnits1 = "PortableUnits1",
    PostalCode = "PostalCode",
    PotentialPersonaEmailList = "PotentialPersonaEmailList",
    PreferredContactMethod = "PreferredContactMethod",
    PrivacyPolicyURL = "PrivacyPolicyURL",
    ProblemBillingDispute1 = "ProblemBillingDispute1",
    ProblemBillingDispute2 = "ProblemBillingDispute2",
    ProblemBillingDispute2Enabled = "ProblemBillingDispute2Enabled",
    ProblemDamagedItems1 = "ProblemDamagedItems1",
    ProblemDamagedItems2 = "ProblemDamagedItems2",
    ProblemDamagedItems2Enabled = "ProblemDamagedItems2Enabled",
    ProblemEmergency1 = "ProblemEmergency1",
    ProblemEmergency2 = "ProblemEmergency2",
    ProblemEmergency2Enabled = "ProblemEmergency2Enabled",
    ProblemGetOut1 = "ProblemGetOut1",
    ProblemGetOut2 = "ProblemGetOut2",
    ProblemGetOut2Enabled = "ProblemGetOut2Enabled",
    ProblemLostKey1 = "ProblemLostKey1",
    ProblemLostKey2 = "ProblemLostKey2",
    ProblemLostKey2Enabled = "ProblemLostKey2Enabled",
    ProblemResolutionChannel = "ProblemResolutionChannel",
    ProblemTagEmailList = "ProblemTagEmailList",
    ProblemTheft1 = "ProblemTheft1",
    ProblemTheft2 = "ProblemTheft2",
    ProblemTheft2Enabled = "ProblemTheft2Enabled",
    ProblemWebIssue1 = "ProblemWebIssue1",
    ProblemWebIssue2 = "ProblemWebIssue2",
    ProblemWebIssue2Enabled = "ProblemWebIssue2Enabled",
    ProfileSettingBotInititatedSalesCollectionMethod = "ProfileSettingBotInititatedSalesCollectionMethod",
    ProfileSettingBotInititatedSalesContactMethod = "ProfileSettingBotInititatedSalesContactMethod",
    ProfileSettingBotInititatedSalesMessage = "ProfileSettingBotInititatedSalesMessage",
    ProfileSettingBotInititatedSalesWantConfirmProfile = "ProfileSettingBotInititatedSalesWantConfirmProfile",
    ProfileSettingBotInititatedSalesWantSecondaryOptional = "ProfileSettingBotInititatedSalesWantSecondaryOptional",
    ProfileSettingBotInititatedSalesWantShortProfile = "ProfileSettingBotInititatedSalesWantShortProfile",
    ProfileSettingBotInititatedServiceCollectionMethod = "ProfileSettingBotInititatedServiceCollectionMethod",
    ProfileSettingBotInititatedServiceContactMethod = "ProfileSettingBotInititatedServiceContactMethod",
    ProfileSettingBotInititatedServiceMessage = "ProfileSettingBotInititatedServiceMessage",
    ProfileSettingBotInititatedServiceWantConfirmProfile = "ProfileSettingBotInititatedServiceWantConfirmProfile",
    ProfileSettingBotInititatedServiceWantSecondaryOptional = "ProfileSettingBotInititatedServiceWantSecondaryOptional",
    ProfileSettingBotInititatedServiceWantShortProfile = "ProfileSettingBotInititatedServiceWantShortProfile",
    ProfileSettingCancelCollectionMethod = "ProfileSettingCancelCollectionMethod",
    ProfileSettingCancelContactMethod = "ProfileSettingCancelContactMethod",
    ProfileSettingCancelMessage = "ProfileSettingCancelMessage",
    ProfileSettingCancelWantConfirmProfile = "ProfileSettingCancelWantConfirmProfile",
    ProfileSettingCancelWantSecondaryOptional = "ProfileSettingCancelWantSecondaryOptional",
    ProfileSettingCancelWantShortProfile = "ProfileSettingCancelWantShortProfile",
    ProfileSettingHumanInitiatedCollectionMethod = "ProfileSettingHumanInitiatedCollectionMethod",
    ProfileSettingHumanInitiatedContactMethod = "ProfileSettingHumanInitiatedContactMethod",
    ProfileSettingHumanInitiatedMessage = "ProfileSettingHumanInitiatedMessage",
    ProfileSettingHumanInitiatedWantConfirmProfile = "ProfileSettingHumanInitiatedWantConfirmProfile",
    ProfileSettingHumanInitiatedWantSecondaryOptional = "ProfileSettingHumanInitiatedWantSecondaryOptional",
    ProfileSettingHumanInitiatedWantShortProfile = "ProfileSettingHumanInitiatedWantShortProfile",
    ProfileSettingLiveChatCollectionMethod = "ProfileSettingLiveChatCollectionMethod",
    ProfileSettingLiveChatContactMethod = "ProfileSettingLiveChatContactMethod",
    ProfileSettingLiveChatMessage = "ProfileSettingLiveChatMessage",
    ProfileSettingLiveChatWantCollectPersona = "ProfileSettingLiveChatWantCollectPersona",
    ProfileSettingLiveChatWantConfirmProfile = "ProfileSettingLiveChatWantConfirmProfile",
    ProfileSettingLiveChatWantSecondaryOptional = "ProfileSettingLiveChatWantSecondaryOptional",
    ProfileSettingLiveChatWantShortProfile = "ProfileSettingLiveChatWantShortProfile",
    ProfileSettingLowConfidenceCollectionMethod = "ProfileSettingLowConfidenceCollectionMethod",
    ProfileSettingLowConfidenceContactMethod = "ProfileSettingLowConfidenceContactMethod",
    ProfileSettingLowConfidenceMessage = "ProfileSettingLowConfidenceMessage",
    ProfileSettingLowConfidenceWantConfirmProfile = "ProfileSettingLowConfidenceWantConfirmProfile",
    ProfileSettingLowConfidenceWantSecondaryOptional = "ProfileSettingLowConfidenceWantSecondaryOptional",
    ProfileSettingLowConfidenceWantShortProfile = "ProfileSettingLowConfidenceWantShortProfile",
    ProfileSettingShoppingCollectionMethod = "ProfileSettingShoppingCollectionMethod",
    ProfileSettingShoppingContactMethod = "ProfileSettingShoppingContactMethod",
    ProfileSettingShoppingMessage = "ProfileSettingShoppingMessage",
    ProfileSettingShoppingWantConfirmProfile = "ProfileSettingShoppingWantConfirmProfile",
    ProfileSettingShoppingWantSecondaryOptional = "ProfileSettingShoppingWantSecondaryOptional",
    ProfileSettingShoppingWantShortProfile = "ProfileSettingShoppingWantShortProfile",
    ProfileSettingWaitlistCollectionMethod = "ProfileSettingWaitlistCollectionMethod",
    ProfileSettingWaitlistCollectProfile = "ProfileSettingWaitlistCollectProfile",
    ProfileSettingWaitlistContactMethod = "ProfileSettingWaitlistContactMethod",
    ProfileSettingWaitlistMessage = "ProfileSettingWaitlistMessage",
    ProfileSettingWaitlistWantConfirmProfile = "ProfileSettingWaitlistWantConfirmProfile",
    ProfileSettingWaitlistWantSecondaryOptional = "ProfileSettingWaitlistWantSecondaryOptional",
    ProfileSettingWaitlistWantShortProfile = "ProfileSettingWaitlistWantShortProfile",
    ProfileSettingWelcomeBackCollectionMethod = "ProfileSettingWelcomeBackCollectionMethod",
    ProfileSettingWelcomeBackCollectProfile = "ProfileSettingWelcomeBackCollectProfile",
    ProfileSettingWelcomeBackContactMethod = "ProfileSettingWelcomeBackContactMethod",
    ProfileSettingWelcomeBackMessage = "ProfileSettingWelcomeBackMessage",
    ProfileSettingWelcomeBackWantCollectPersona = "ProfileSettingWelcomeBackWantCollectPersona",
    ProfileSettingWelcomeBackWantConfirmProfile = "ProfileSettingWelcomeBackWantConfirmProfile",
    ProfileSettingWelcomeBackWantSecondaryOptional = "ProfileSettingWelcomeBackWantSecondaryOptional",
    ProfileSettingWelcomeBackWantShortProfile = "ProfileSettingWelcomeBackWantShortProfile",
    ProfileSettingWelcomeCollectionMethod = "ProfileSettingWelcomeCollectionMethod",
    ProfileSettingWelcomeCollectProfile = "ProfileSettingWelcomeCollectProfile",
    ProfileSettingWelcomeContactMethod = "ProfileSettingWelcomeContactMethod",
    ProfileSettingWelcomeMessage = "ProfileSettingWelcomeMessage",
    ProfileSettingWelcomeWantCollectPersona = "ProfileSettingWelcomeWantCollectPersona",
    ProfileSettingWelcomeWantConfirmProfile = "ProfileSettingWelcomeWantConfirmProfile",
    ProfileSettingWelcomeWantSecondaryOptional = "ProfileSettingWelcomeWantSecondaryOptional",
    ProfileSettingWelcomeWantShortProfile = "ProfileSettingWelcomeWantShortProfile",
    ProfileSettingWhatElseCollectionMethod = "ProfileSettingWhatElseCollectionMethod",
    ProfileSettingWhatElseCollectProfile = "ProfileSettingWhatElseCollectProfile",
    ProfileSettingWhatElseContactMethod = "ProfileSettingWhatElseContactMethod",
    ProfileSettingWhatElseMessage = "ProfileSettingWhatElseMessage",
    ProfileSettingWhatElseWantConfirmProfile = "ProfileSettingWhatElseWantConfirmProfile",
    ProfileSettingWhatElseWantSecondaryOptional = "ProfileSettingWhatElseWantSecondaryOptional",
    ProfileSettingWhatElseWantShortProfile = "ProfileSettingWhatElseWantShortProfile",
    PurchaseFranchise1 = "PurchaseFranchise1",
    PurchaseFranchise2 = "PurchaseFranchise2",
    PurchaseFranchise2Enabled = "PurchaseFranchise2Enabled",
    PurchaseIdentification1 = "PurchaseIdentification1",
    PurchaseMonthlyPayments1 = "PurchaseMonthlyPayments1",
    PurchaseMonthlyPayments2 = "PurchaseMonthlyPayments2",
    PurchaseMonthlyPayments2Enabled = "PurchaseMonthlyPayments2Enabled",
    PurchasePaymentOptions1 = "PurchasePaymentOptions1",
    PurchasePaymentOptions2 = "PurchasePaymentOptions2",
    PurchasePaymentOptions2Enabled = "PurchasePaymentOptions2Enabled",
    PurchasePayOnline1 = "PurchasePayOnline1",
    PurchasePayOnline2 = "PurchasePayOnline2",
    PurchasePayOnline2Enabled = "PurchasePayOnline2Enabled",
    QuickReplyCheckInventory = "QuickReplyCheckInventory",
    QuickReplyClosing = "QuickReplyClosing",
    QuickReplyGoogleReview = "QuickReplyGoogleReview",
    QuickReplyGreeting = "QuickReplyGreeting",
    QuickReplyMove2Text = "QuickReplyMove2Text",
    QuickReplyPhoneNumber1 = "QuickReplyPhoneNumber1",
    QuickReplyPhoneNumber2 = "QuickReplyPhoneNumber2",
    QuickReplyReservation = "QuickReplyReservation",
    QuickReplyStoring = "QuickReplyStoring",
    QuickReplyUnderstandFeature = "QuickReplyUnderstandFeature",
    QuickReplyUnderstandSize = "QuickReplyUnderstandSize",
    QuickReplyUsage = "QuickReplyUsage",
    QuickReplyWhatElse = "QuickReplyWhatElse",
    QuickReplyWhen = "QuickReplyWhen",
    RecycleURL = "RecycleURL",
    ReferralIncentive = "ReferralIncentive",
    ReferralProgramURL = "ReferralProgramURL",
    ResponseSentenceLimit = "ResponseSentenceLimit",
    ReviewEmailReceiptThreshold = "ReviewEmailReceiptThreshold",
    ReviewReply1Star = "ReviewReply1Star",
    ReviewReply5Star = "ReviewReply5Star",
    ReviewReplyDetractor = "ReviewReplyDetractor",
    ReviewReplyGeneral = "ReviewReplyGeneral",
    ReviewReplyPassive = "ReviewReplyPassive",
    ReviewReplyPromoter = "ReviewReplyPromoter",
    RVParking1 = "RVParking1",
    RVParking2 = "RVParking2",
    RVParking2Enabled = "RVParking2Enabled",
    RVParkingCovered1 = "RVParkingCovered1",
    RVParkingCovered2 = "RVParkingCovered2",
    RVParkingCovered2Enabled = "RVParkingCovered2Enabled",
    RVParkingEnclosed1 = "RVParkingEnclosed1",
    RVParkingEnclosed2 = "RVParkingEnclosed2",
    RVParkingEnclosed2Enabled = "RVParkingEnclosed2Enabled",
    S3AnalyticsDir = "S3AnalyticsDir",
    SalesTagEmailList = "SalesTagEmailList",
    SecondaryLanguage = "SecondaryLanguage",
    SecurityAmenities = "SecurityAmenities",
    SequenceAbandonedCartDay00Enabled = "SequenceAbandonedCartDay00Enabled",
    SequenceAbandonedCartDay00MaxTime = "SequenceAbandonedCartDay00MaxTime",
    SequenceAbandonedCartDay00MinTime = "SequenceAbandonedCartDay00MinTime",
    SequenceAbandonedCartDay01ActuallyEnabled = "SequenceAbandonedCartDay01ActuallyEnabled",
    SequenceAbandonedCartDay01Enabled = "SequenceAbandonedCartDay01Enabled",
    SequenceAbandonedCartDay01Time = "SequenceAbandonedCartDay01Time",
    SequenceAbandonedCartDay01TimeInUTC = "SequenceAbandonedCartDay01TimeInUTC",
    SequenceAbandonedCartDay02Enabled = "SequenceAbandonedCartDay02Enabled",
    SequenceAbandonedCartDay02Time = "SequenceAbandonedCartDay02Time",
    SequenceAbandonedCartDay02TimeInUTC = "SequenceAbandonedCartDay02TimeInUTC",
    SequenceAbandonedCartDay03Enabled = "SequenceAbandonedCartDay03Enabled",
    SequenceAbandonedCartDay03Time = "SequenceAbandonedCartDay03Time",
    SequenceAbandonedCartDay03TimeInUTC = "SequenceAbandonedCartDay03TimeInUTC",
    SequenceAbandonedCartDay05Enabled = "SequenceAbandonedCartDay05Enabled",
    SequenceAbandonedCartDay05Time = "SequenceAbandonedCartDay05Time",
    SequenceAbandonedCartDay05TimeInUTC = "SequenceAbandonedCartDay05TimeInUTC",
    SequenceAbandonedCartDay07Enabled = "SequenceAbandonedCartDay07Enabled",
    SequenceAbandonedCartDay07Time = "SequenceAbandonedCartDay07Time",
    SequenceAbandonedCartDay07TimeInUTC = "SequenceAbandonedCartDay07TimeInUTC",
    SequenceAbandonedCartDay10Enabled = "SequenceAbandonedCartDay10Enabled",
    SequenceAbandonedCartDay10Time = "SequenceAbandonedCartDay10Time",
    SequenceAbandonedCartDay10TimeInUTC = "SequenceAbandonedCartDay10TimeInUTC",
    SequenceAbandonedCartDay14Enabled = "SequenceAbandonedCartDay14Enabled",
    SequenceAbandonedCartDay14Time = "SequenceAbandonedCartDay14Time",
    SequenceAbandonedCartDay14TimeInUTC = "SequenceAbandonedCartDay14TimeInUTC",
    SequenceAbandonedCartDay30Enabled = "SequenceAbandonedCartDay30Enabled",
    SequenceAbandonedCartDay30Time = "SequenceAbandonedCartDay30Time",
    SequenceAbandonedCartDay30TimeInUTC = "SequenceAbandonedCartDay30TimeInUTC",
    SequenceMoveInDay00ActuallyEnabled = "SequenceMoveInDay00ActuallyEnabled",
    SequenceMoveInDay00Enabled = "SequenceMoveInDay00Enabled",
    SequenceMoveInDay00MaxTime = "SequenceMoveInDay00MaxTime",
    SequenceMoveInDay00MinTime = "SequenceMoveInDay00MinTime",
    SequenceMoveInDay01Enabled = "SequenceMoveInDay01Enabled",
    SequenceMoveInDay01Time = "SequenceMoveInDay01Time",
    SequenceMoveInDay01TimeInUTC = "SequenceMoveInDay01TimeInUTC",
    SequenceMoveInDay02Enabled = "SequenceMoveInDay02Enabled",
    SequenceMoveInDay02Time = "SequenceMoveInDay02Time",
    SequenceMoveInDay02TimeInUTC = "SequenceMoveInDay02TimeInUTC",
    SequenceMoveInDay03Enabled = "SequenceMoveInDay03Enabled",
    SequenceMoveInDay03Time = "SequenceMoveInDay03Time",
    SequenceMoveInDay03TimeInUTC = "SequenceMoveInDay03TimeInUTC",
    SequenceMoveInDay05Enabled = "SequenceMoveInDay05Enabled",
    SequenceMoveInDay05Time = "SequenceMoveInDay05Time",
    SequenceMoveInDay05TimeInUTC = "SequenceMoveInDay05TimeInUTC",
    SequenceMoveInDay07Enabled = "SequenceMoveInDay07Enabled",
    SequenceMoveInDay07Time = "SequenceMoveInDay07Time",
    SequenceMoveInDay07TimeInUTC = "SequenceMoveInDay07TimeInUTC",
    SequenceMoveInDay10Enabled = "SequenceMoveInDay10Enabled",
    SequenceMoveInDay10Time = "SequenceMoveInDay10Time",
    SequenceMoveInDay10TimeInUTC = "SequenceMoveInDay10TimeInUTC",
    SequenceMoveInDay14Enabled = "SequenceMoveInDay14Enabled",
    SequenceMoveInDay14Time = "SequenceMoveInDay14Time",
    SequenceMoveInDay14TimeInUTC = "SequenceMoveInDay14TimeInUTC",
    SequenceMoveInDay30Enabled = "SequenceMoveInDay30Enabled",
    SequenceMoveInDay30Time = "SequenceMoveInDay30Time",
    SequenceMoveInDay30TimeInUTC = "SequenceMoveInDay30TimeInUTC",
    SequenceMoveInDay90Enabled = "SequenceMoveInDay90Enabled",
    SequenceMoveInDay90Time = "SequenceMoveInDay90Time",
    SequenceMoveInDay90TimeInUTC = "SequenceMoveInDay90TimeInUTC",
    SequenceMoveOutDay00Enabled = "SequenceMoveOutDay00Enabled",
    SequenceMoveOutDay00MaxTime = "SequenceMoveOutDay00MaxTime",
    SequenceMoveOutDay00MinTime = "SequenceMoveOutDay00MinTime",
    SequenceMoveOutDay01Enabled = "SequenceMoveOutDay01Enabled",
    SequenceMoveOutDay01Time = "SequenceMoveOutDay01Time",
    SequenceMoveOutDay01TimeInUTC = "SequenceMoveOutDay01TimeInUTC",
    SequenceMoveOutDay02Enabled = "SequenceMoveOutDay02Enabled",
    SequenceMoveOutDay02Time = "SequenceMoveOutDay02Time",
    SequenceMoveOutDay02TimeInUTC = "SequenceMoveOutDay02TimeInUTC",
    SequenceMoveOutDay03Enabled = "SequenceMoveOutDay03Enabled",
    SequenceMoveOutDay03Time = "SequenceMoveOutDay03Time",
    SequenceMoveOutDay03TimeInUTC = "SequenceMoveOutDay03TimeInUTC",
    SequenceMoveOutDay05Enabled = "SequenceMoveOutDay05Enabled",
    SequenceMoveOutDay05Time = "SequenceMoveOutDay05Time",
    SequenceMoveOutDay05TimeInUTC = "SequenceMoveOutDay05TimeInUTC",
    SequenceMoveOutDay07Enabled = "SequenceMoveOutDay07Enabled",
    SequenceMoveOutDay07Time = "SequenceMoveOutDay07Time",
    SequenceMoveOutDay07TimeInUTC = "SequenceMoveOutDay07TimeInUTC",
    SequenceMoveOutDay10Enabled = "SequenceMoveOutDay10Enabled",
    SequenceMoveOutDay10Time = "SequenceMoveOutDay10Time",
    SequenceMoveOutDay10TimeInUTC = "SequenceMoveOutDay10TimeInUTC",
    SequenceMoveOutDay14Enabled = "SequenceMoveOutDay14Enabled",
    SequenceMoveOutDay14Time = "SequenceMoveOutDay14Time",
    SequenceMoveOutDay14TimeInUTC = "SequenceMoveOutDay14TimeInUTC",
    SequenceMoveOutDay30Enabled = "SequenceMoveOutDay30Enabled",
    SequenceMoveOutDay30Time = "SequenceMoveOutDay30Time",
    SequenceMoveOutDay30TimeInUTC = "SequenceMoveOutDay30TimeInUTC",
    SequenceMoveOutDay90Enabled = "SequenceMoveOutDay90Enabled",
    SequenceMoveOutDay90Time = "SequenceMoveOutDay90Time",
    SequenceMoveOutDay90TimeInUTC = "SequenceMoveOutDay90TimeInUTC",
    SequencePastDueDay00Enabled = "SequencePastDueDay00Enabled",
    SequencePastDueDay00Time = "SequencePastDueDay00Time",
    SequencePastDueDay00TimeInUTC = "SequencePastDueDay00TimeInUTC",
    SequencePastDueDay01Enabled = "SequencePastDueDay01Enabled",
    SequencePastDueDay01Time = "SequencePastDueDay01Time",
    SequencePastDueDay01TimeInUTC = "SequencePastDueDay01TimeInUTC",
    SequencePastDueDay02Enabled = "SequencePastDueDay02Enabled",
    SequencePastDueDay02Time = "SequencePastDueDay02Time",
    SequencePastDueDay02TimeInUTC = "SequencePastDueDay02TimeInUTC",
    SequencePastDueDay03Enabled = "SequencePastDueDay03Enabled",
    SequencePastDueDay03Time = "SequencePastDueDay03Time",
    SequencePastDueDay03TimeInUTC = "SequencePastDueDay03TimeInUTC",
    SequencePastDueDay05Enabled = "SequencePastDueDay05Enabled",
    SequencePastDueDay05Time = "SequencePastDueDay05Time",
    SequencePastDueDay05TimeInUTC = "SequencePastDueDay05TimeInUTC",
    SequencePastDueDay07Enabled = "SequencePastDueDay07Enabled",
    SequencePastDueDay07Time = "SequencePastDueDay07Time",
    SequencePastDueDay07TimeInUTC = "SequencePastDueDay07TimeInUTC",
    SequencePastDueDay10Enabled = "SequencePastDueDay10Enabled",
    SequencePastDueDay10Time = "SequencePastDueDay10Time",
    SequencePastDueDay10TimeInUTC = "SequencePastDueDay10TimeInUTC",
    SequencePastDueDay14Enabled = "SequencePastDueDay14Enabled",
    SequencePastDueDay14Time = "SequencePastDueDay14Time",
    SequencePastDueDay14TimeInUTC = "SequencePastDueDay14TimeInUTC",
    SequencePastDueDay30Enabled = "SequencePastDueDay30Enabled",
    SequencePastDueDay30Time = "SequencePastDueDay30Time",
    SequencePastDueDay30TimeInUTC = "SequencePastDueDay30TimeInUTC",
    SequencePastDueDay45Enabled = "SequencePastDueDay45Enabled",
    SequencePastDueDay45Time = "SequencePastDueDay45Time",
    SequencePastDueDay45TimeInUTC = "SequencePastDueDay45TimeInUTC",
    SequencePastDueProcessInactiveStatuses = "SequencePastDueProcessInactiveStatuses",
    SequencePastDueRecurringEnabled = "SequencePastDueRecurringEnabled",
    SequencePastDueRecurringTime = "SequencePastDueRecurringTime",
    SequencePastDueRecurringTimeInUTC = "SequencePastDueRecurringTimeInUTC",
    ServiceTagEmailList = "ServiceTagEmailList",
    ShowInventory1 = "ShowInventory1",
    ShowInventory1Enabled = "ShowInventory1Enabled",
    ShowSizeDescriptions = "ShowSizeDescriptions",
    ShredURL = "ShredURL",
    SitelinkAbandonedCartLeadStatuses = "SitelinkAbandonedCartLeadStatuses",
    SizeDescription10x101 = "SizeDescription10x101",
    SizeDescription10x102 = "SizeDescription10x102",
    SizeDescription10x102Enabled = "SizeDescription10x102Enabled",
    SizeDescription10x151 = "SizeDescription10x151",
    SizeDescription10x152 = "SizeDescription10x152",
    SizeDescription10x152Enabled = "SizeDescription10x152Enabled",
    SizeDescription10x201 = "SizeDescription10x201",
    SizeDescription10x202 = "SizeDescription10x202",
    SizeDescription10x202Enabled = "SizeDescription10x202Enabled",
    SizeDescription10x301 = "SizeDescription10x301",
    SizeDescription10x302 = "SizeDescription10x302",
    SizeDescription10x302Enabled = "SizeDescription10x302Enabled",
    SizeDescription1Bedroom1 = "SizeDescription1Bedroom1",
    SizeDescription1Bedroom2 = "SizeDescription1Bedroom2",
    SizeDescription1Bedroom2Enabled = "SizeDescription1Bedroom2Enabled",
    SizeDescription2Bedroom1 = "SizeDescription2Bedroom1",
    SizeDescription2Bedroom2 = "SizeDescription2Bedroom2",
    SizeDescription2Bedroom2Enabled = "SizeDescription2Bedroom2Enabled",
    SizeDescription3Bedroom1 = "SizeDescription3Bedroom1",
    SizeDescription3Bedroom2 = "SizeDescription3Bedroom2",
    SizeDescription3Bedroom2Enabled = "SizeDescription3Bedroom2Enabled",
    SizeDescription45Bedroom1 = "SizeDescription45Bedroom1",
    SizeDescription45Bedroom2 = "SizeDescription45Bedroom2",
    SizeDescription45Bedroom2Enabled = "SizeDescription45Bedroom2Enabled",
    SizeDescription5x101 = "SizeDescription5x101",
    SizeDescription5x102 = "SizeDescription5x102",
    SizeDescription5x102Enabled = "SizeDescription5x102Enabled",
    SizeDescription5x51 = "SizeDescription5x51",
    SizeDescription5x52 = "SizeDescription5x52",
    SizeDescription5x52Enabled = "SizeDescription5x52Enabled",
    SizeDescriptionExtraLarge1 = "SizeDescriptionExtraLarge1",
    SizeDescriptionExtraLarge2 = "SizeDescriptionExtraLarge2",
    SizeDescriptionExtraLarge2Enabled = "SizeDescriptionExtraLarge2Enabled",
    SizeDescriptionLarge1 = "SizeDescriptionLarge1",
    SizeDescriptionLarge2 = "SizeDescriptionLarge2",
    SizeDescriptionLarge2Enabled = "SizeDescriptionLarge2Enabled",
    SizeDescriptionMedium1 = "SizeDescriptionMedium1",
    SizeDescriptionMedium2 = "SizeDescriptionMedium2",
    SizeDescriptionMedium2Enabled = "SizeDescriptionMedium2Enabled",
    SizeDescriptionMotorcycle1 = "SizeDescriptionMotorcycle1",
    SizeDescriptionMotorcycle2 = "SizeDescriptionMotorcycle2",
    SizeDescriptionMotorcycle2Enabled = "SizeDescriptionMotorcycle2Enabled",
    SizeDescriptionRV1 = "SizeDescriptionRV1",
    SizeDescriptionRV2 = "SizeDescriptionRV2",
    SizeDescriptionRV2Enabled = "SizeDescriptionRV2Enabled",
    SizeDescriptionSedan1 = "SizeDescriptionSedan1",
    SizeDescriptionSedan2 = "SizeDescriptionSedan2",
    SizeDescriptionSedan2Enabled = "SizeDescriptionSedan2Enabled",
    SizeDescriptionSmall1 = "SizeDescriptionSmall1",
    SizeDescriptionSmall2 = "SizeDescriptionSmall2",
    SizeDescriptionSmall2Enabled = "SizeDescriptionSmall2Enabled",
    SizeDescriptionSmallVehicle1 = "SizeDescriptionSmallVehicle1",
    SizeDescriptionSmallVehicle2 = "SizeDescriptionSmallVehicle2",
    SizeDescriptionSmallVehicle2Enabled = "SizeDescriptionSmallVehicle2Enabled",
    SizeDescriptionTruck1 = "SizeDescriptionTruck1",
    SizeDescriptionTruck2 = "SizeDescriptionTruck2",
    SizeDescriptionTruck2Enabled = "SizeDescriptionTruck2Enabled",
    SizeVisualsURL = "SizeVisualsURL",
    SlackAppId = "SlackAppId",
    SMSFirstMessageDisclaimer = "SMSFirstMessageDisclaimer",
    SpecialHours = "SpecialHours",
    SpotAccessCodeQuestSlug = "SpotAccessCodeQuestSlug",
    SpotBrandSlug = "SpotBrandSlug",
    SpotButtons = "SpotButtons",
    SpotLinkSlug = "SpotLinkSlug",
    SpotLocationSlug = "SpotLocationSlug",
    SpotManageAccountQuestSlug = "SpotManageAccountQuestSlug",
    SpotPayBillOnlineQuestSlug = "SpotPayBillOnlineQuestSlug",
    SpotPayBillPhoneQuestSlug = "SpotPayBillPhoneQuestSlug",
    SpotReferralInChatMessage = "SpotReferralInChatMessage",
    SpotReferralMessage1 = "SpotReferralMessage1",
    SpotReferralMessage2 = "SpotReferralMessage2",
    SpotReferralMessage2Enabled = "SpotReferralMessage2Enabled",
    SpotReferralPageBody = "SpotReferralPageBody",
    SpotReferralPageTitle = "SpotReferralPageTitle",
    SpotReferralReferralCollectionMethod = "SpotReferralReferralCollectionMethod",
    SpotReferralReferralConfirm1 = "SpotReferralReferralConfirm1",
    SpotReferralReferralContactMethod = "SpotReferralReferralContactMethod",
    SpotReferralReferralWantSecondaryOptional = "SpotReferralReferralWantSecondaryOptional",
    SpotReferralReferralWantShortProfile = "SpotReferralReferralWantShortProfile",
    SpotReferralShareEmailBody = "SpotReferralShareEmailBody",
    SpotReferralShareEmailSubject = "SpotReferralShareEmailSubject",
    SpotReferralShareSMSBody = "SpotReferralShareSMSBody",
    SpotReferralURL = "SpotReferralURL",
    SpotReviewDisclaimer = "SpotReviewDisclaimer",
    SpotReviewDisclaimerEnabled = "SpotReviewDisclaimerEnabled",
    SpotReviewPageTitle = "SpotReviewPageTitle",
    SpotReviewQuestSlug = "SpotReviewQuestSlug",
    StandardCeilingHeight = "StandardCeilingHeight",
    State = "State",
    StoragelyClientID = "StoragelyClientID",
    StoragePugSingleLocationBaseURL = "StoragePugSingleLocationBaseURL",
    SubscriptionAdvancedEmbed = "SubscriptionAdvancedEmbed",
    SubscriptionCanTrain = "SubscriptionCanTrain",
    SubscriptionEscalationSummary = "SubscriptionEscalationSummary",
    SubscriptionMaxUsers = "SubscriptionMaxUsers",
    SubscriptionMonthlyTrainingHours = "SubscriptionMonthlyTrainingHours",
    SubscriptionMultipleBrainTiers = "SubscriptionMultipleBrainTiers",
    SubscriptionOnboardingHours = "SubscriptionOnboardingHours",
    SubscriptionPlanName = "SubscriptionPlanName",
    SubscriptionPremiumApps = "SubscriptionPremiumApps",
    SubscriptionStatus = "SubscriptionStatus",
    SubscriptionSupportTier = "SubscriptionSupportTier",
    swivlCodaDocID = "swivlCodaDocID",
    swivlCodaTableID = "swivlCodaTableID",
    swivlHasGoogleReviews = "swivlHasGoogleReviews",
    swivlHasSMS = "swivlHasSMS",
    swivlHasVoice = "swivlHasVoice",
    swivlLeadEmailList = "swivlLeadEmailList",
    Timezone = "Timezone",
    TruckTypes = "TruckTypes",
    TwilioApiKey = "TwilioApiKey",
    TwilioApiSecret = "TwilioApiSecret",
    TwilioAppId = "TwilioAppId",
    TwilioSubaccountApiKey = "TwilioSubaccountApiKey",
    TwilioSubaccountApiSecret = "TwilioSubaccountApiSecret",
    TwilioSubaccountAuthToken = "TwilioSubaccountAuthToken",
    TwilioSubaccountSID = "TwilioSubaccountSID",
    TwoUnhandledBeforeEscalation = "TwoUnhandledBeforeEscalation",
    UnitPageUrl = "UnitPageUrl",
    UnknownPersonaEmailList = "UnknownPersonaEmailList",
    UnknownTagEmailList = "UnknownTagEmailList",
    UpperLevelDisplayName = "UpperLevelDisplayName",
    URLFormatLocations = "URLFormatLocations",
    URLLookupPattern = "URLLookupPattern",
    VariesLoginURL = "VariesLoginURL",
    VariesPayOnlineURL = "VariesPayOnlineURL",
    VariesSizeVisualsURL = "VariesSizeVisualsURL",
    VarySettings = "VarySettings",
    VBPDescription1 = "VBPDescription1",
    VBPDescription2 = "VBPDescription2",
    VBPDescription3 = "VBPDescription3",
    VBPName1 = "VBPName1",
    VBPName2 = "VBPName2",
    VBPName3 = "VBPName3",
    VehicleStorage1 = "VehicleStorage1",
    VehicleStorage2 = "VehicleStorage2",
    VehicleStorage2Enabled = "VehicleStorage2Enabled",
    VehicleStorageCovered1 = "VehicleStorageCovered1",
    VehicleStorageCovered2 = "VehicleStorageCovered2",
    VehicleStorageCovered2Enabled = "VehicleStorageCovered2Enabled",
    VehicleStorageGuidelines1 = "VehicleStorageGuidelines1",
    VehicleStorageGuidelines2 = "VehicleStorageGuidelines2",
    VehicleStorageGuidelines3 = "VehicleStorageGuidelines3",
    VehicleStorageGuidelines3Enabled = "VehicleStorageGuidelines3Enabled",
    VehicleStorageGuidelines4 = "VehicleStorageGuidelines4",
    VehicleStorageGuidelines4Enabled = "VehicleStorageGuidelines4Enabled",
    VehicleStorageIndoor1 = "VehicleStorageIndoor1",
    VehicleStorageIndoor2 = "VehicleStorageIndoor2",
    VehicleStorageIndoor2Enabled = "VehicleStorageIndoor2Enabled",
    VoiceAccountBalanceAdditionalVerificationInfo = "VoiceAccountBalanceAdditionalVerificationInfo",
    VoiceAccountBalanceEscalateTo = "VoiceAccountBalanceEscalateTo",
    VoiceAccountBalanceFound = "VoiceAccountBalanceFound",
    VoiceAccountBalanceHasAdditionalVerification = "VoiceAccountBalanceHasAdditionalVerification",
    VoiceAccountBalanceHasLLM = "VoiceAccountBalanceHasLLM",
    VoiceAccountBalanceMessage = "VoiceAccountBalanceMessage",
    VoiceAccountBalanceNotFound = "VoiceAccountBalanceNotFound",
    VoiceAccountBalancePhoneNumber = "VoiceAccountBalancePhoneNumber",
    VoiceAccountBalanceTextMessage = "VoiceAccountBalanceTextMessage",
    VoiceAccountNumberEscalateTo = "VoiceAccountNumberEscalateTo",
    VoiceAccountNumberFound = "VoiceAccountNumberFound",
    VoiceAccountNumberHasLLM = "VoiceAccountNumberHasLLM",
    VoiceAccountNumberMessage = "VoiceAccountNumberMessage",
    VoiceAccountNumberNotFound = "VoiceAccountNumberNotFound",
    VoiceAccountNumberPhoneNumber = "VoiceAccountNumberPhoneNumber",
    VoiceAccountNumberTextMessage = "VoiceAccountNumberTextMessage",
    VoiceAfterHoursEmergencyAlertContent = "VoiceAfterHoursEmergencyAlertContent",
    VoiceAfterHoursEmergencyCriteria = "VoiceAfterHoursEmergencyCriteria",
    VoiceAfterHoursEmergencyEmails = "VoiceAfterHoursEmergencyEmails",
    VoiceAfterHoursEmergencyForwardPhoneNumber = "VoiceAfterHoursEmergencyForwardPhoneNumber",
    VoiceAfterHoursEmergencyHasEmail = "VoiceAfterHoursEmergencyHasEmail",
    VoiceAfterHoursEmergencyHasForward = "VoiceAfterHoursEmergencyHasForward",
    VoiceAfterHoursEmergencyHasSMS = "VoiceAfterHoursEmergencyHasSMS",
    VoiceAfterHoursEmergencySMSPhoneNumbers = "VoiceAfterHoursEmergencySMSPhoneNumbers",
    VoiceAfterHoursEmergencyVoiceMessage = "VoiceAfterHoursEmergencyVoiceMessage",
    VoiceAnythingElseMessage = "VoiceAnythingElseMessage",
    VoiceAutopayEscalateTo = "VoiceAutopayEscalateTo",
    VoiceAutopayHasLLM = "VoiceAutopayHasLLM",
    VoiceAutopayMessage = "VoiceAutopayMessage",
    VoiceAutopayPhoneNumber = "VoiceAutopayPhoneNumber",
    VoiceAutopayTextMessage = "VoiceAutopayTextMessage",
    VoiceCancelEscalateTo = "VoiceCancelEscalateTo",
    VoiceCancelHasLLM = "VoiceCancelHasLLM",
    VoiceCancelMessage = "VoiceCancelMessage",
    VoiceCancelPhoneNumber = "VoiceCancelPhoneNumber",
    VoiceCancelTextMessage = "VoiceCancelTextMessage",
    VoiceDelinquentWelcomeMessage = "VoiceDelinquentWelcomeMessage",
    VoiceEditAccountInfoEscalateTo = "VoiceEditAccountInfoEscalateTo",
    VoiceEditAccountInfoHasLLM = "VoiceEditAccountInfoHasLLM",
    VoiceEditAccountInfoMessage = "VoiceEditAccountInfoMessage",
    VoiceEditAccountInfoPhoneNumber = "VoiceEditAccountInfoPhoneNumber",
    VoiceEditAccountInfoTextMessage = "VoiceEditAccountInfoTextMessage",
    VoiceForwardAccountBalance = "VoiceForwardAccountBalance",
    VoiceForwardAccountNumber = "VoiceForwardAccountNumber",
    VoiceForwardAutopay = "VoiceForwardAutopay",
    VoiceForwardCancel = "VoiceForwardCancel",
    VoiceForwardEditAccountInfo = "VoiceForwardEditAccountInfo",
    VoiceForwardGateCode = "VoiceForwardGateCode",
    VoiceForwardGetLease = "VoiceForwardGetLease",
    VoiceForwardLoginIssues = "VoiceForwardLoginIssues",
    VoiceForwardManageInsurance = "VoiceForwardManageInsurance",
    VoiceForwardPayBill = "VoiceForwardPayBill",
    VoiceForwardPaymentHistory = "VoiceForwardPaymentHistory",
    VoiceForwardShowInventory = "VoiceForwardShowInventory",
    VoiceFoundAccountBalanceText = "VoiceFoundAccountBalanceText",
    VoiceFoundAccountNumberText = "VoiceFoundAccountNumberText",
    VoiceFoundGateCodeText = "VoiceFoundGateCodeText",
    VoiceGateCodeAdditionalVerificationInfo = "VoiceGateCodeAdditionalVerificationInfo",
    VoiceGateCodeEscalateTo = "VoiceGateCodeEscalateTo",
    VoiceGateCodeFound = "VoiceGateCodeFound",
    VoiceGateCodeHasAdditionalVerification = "VoiceGateCodeHasAdditionalVerification",
    VoiceGateCodeHasLLM = "VoiceGateCodeHasLLM",
    VoiceGateCodeMessage = "VoiceGateCodeMessage",
    VoiceGateCodeNotFound = "VoiceGateCodeNotFound",
    VoiceGateCodePhoneNumber = "VoiceGateCodePhoneNumber",
    VoiceGateCodeTextMessage = "VoiceGateCodeTextMessage",
    VoiceGetLeaseEscalateTo = "VoiceGetLeaseEscalateTo",
    VoiceGetLeaseHasLLM = "VoiceGetLeaseHasLLM",
    VoiceGetLeaseMessage = "VoiceGetLeaseMessage",
    VoiceGetLeasePhoneNumber = "VoiceGetLeasePhoneNumber",
    VoiceGetLeaseTextMessage = "VoiceGetLeaseTextMessage",
    VoiceHangupMessage = "VoiceHangupMessage",
    VoiceHasAccountBalance = "VoiceHasAccountBalance",
    VoiceHasAccountBalanceIntegration = "VoiceHasAccountBalanceIntegration",
    VoiceHasAccountNumber = "VoiceHasAccountNumber",
    VoiceHasAccountNumberIntegration = "VoiceHasAccountNumberIntegration",
    VoiceHasAutopay = "VoiceHasAutopay",
    VoiceHasCancel = "VoiceHasCancel",
    VoiceHasEditAccountInfo = "VoiceHasEditAccountInfo",
    VoiceHasGateCode = "VoiceHasGateCode",
    VoiceHasGateCodeIntegration = "VoiceHasGateCodeIntegration",
    VoiceHasGetLease = "VoiceHasGetLease",
    VoiceHasLoginIssues = "VoiceHasLoginIssues",
    VoiceHasManageInsurance = "VoiceHasManageInsurance",
    VoiceHasPayBill = "VoiceHasPayBill",
    VoiceHasPaymentHistory = "VoiceHasPaymentHistory",
    VoiceHasShowInventory = "VoiceHasShowInventory",
    VoiceLoginIssuesEscalateTo = "VoiceLoginIssuesEscalateTo",
    VoiceLoginIssuesHasLLM = "VoiceLoginIssuesHasLLM",
    VoiceLoginIssuesMessage = "VoiceLoginIssuesMessage",
    VoiceLoginIssuesPhoneNumber = "VoiceLoginIssuesPhoneNumber",
    VoiceLoginIssuesTextMessage = "VoiceLoginIssuesTextMessage",
    VoicemailPhoneNumber = "VoicemailPhoneNumber",
    VoiceManageInsuranceEscalateTo = "VoiceManageInsuranceEscalateTo",
    VoiceManageInsuranceHasLLM = "VoiceManageInsuranceHasLLM",
    VoiceManageInsuranceMessage = "VoiceManageInsuranceMessage",
    VoiceManageInsurancePhoneNumber = "VoiceManageInsurancePhoneNumber",
    VoiceManageInsuranceTextMessage = "VoiceManageInsuranceTextMessage",
    VoiceNoAgentAvailableSales1 = "VoiceNoAgentAvailableSales1",
    VoiceNoAgentAvailableService1 = "VoiceNoAgentAvailableService1",
    VoicePayBillEscalateTo = "VoicePayBillEscalateTo",
    VoicePayBillHasLLM = "VoicePayBillHasLLM",
    VoicePayBillMessage = "VoicePayBillMessage",
    VoicePayBillPermissionToEscalateMessage = "VoicePayBillPermissionToEscalateMessage",
    VoicePayBillPhoneNumber = "VoicePayBillPhoneNumber",
    VoicePayBillTextMessage = "VoicePayBillTextMessage",
    VoicePaymentHistoryEscalateTo = "VoicePaymentHistoryEscalateTo",
    VoicePaymentHistoryHasLLM = "VoicePaymentHistoryHasLLM",
    VoicePaymentHistoryMessage = "VoicePaymentHistoryMessage",
    VoicePaymentHistoryPhoneNumber = "VoicePaymentHistoryPhoneNumber",
    VoicePaymentHistoryTextMessage = "VoicePaymentHistoryTextMessage",
    VoicePermissionToEscalateMessage = "VoicePermissionToEscalateMessage",
    VoicePreEscalateMessage = "VoicePreEscalateMessage",
    VoicePreWelcomeMessage = "VoicePreWelcomeMessage",
    VoiceSalesEscalateTo = "VoiceSalesEscalateTo",
    VoiceSalesPhoneNumber = "VoiceSalesPhoneNumber",
    VoiceSalesPhoneNumberExtension = "VoiceSalesPhoneNumberExtension",
    VoiceSendAccountBalanceText = "VoiceSendAccountBalanceText",
    VoiceSendAccountNumberText = "VoiceSendAccountNumberText",
    VoiceSendAccountNumberTextFound = "VoiceSendAccountNumberTextFound",
    VoiceSendAutopayText = "VoiceSendAutopayText",
    VoiceSendCancelText = "VoiceSendCancelText",
    VoiceSendEditAccountInfoText = "VoiceSendEditAccountInfoText",
    VoiceSendFoundAccountBalanceText = "VoiceSendFoundAccountBalanceText",
    VoiceSendFoundGateCodeText = "VoiceSendFoundGateCodeText",
    VoiceSendGateCodeText = "VoiceSendGateCodeText",
    VoiceSendGetLeaseText = "VoiceSendGetLeaseText",
    VoiceSendLoginIssuesText = "VoiceSendLoginIssuesText",
    VoiceSendManageInsuranceText = "VoiceSendManageInsuranceText",
    VoiceSendPayBillText = "VoiceSendPayBillText",
    VoiceSendPaymentHistoryText = "VoiceSendPaymentHistoryText",
    VoiceSendShowInventoryText = "VoiceSendShowInventoryText",
    VoiceServiceEscalateTo = "VoiceServiceEscalateTo",
    VoiceServicePhoneNumber = "VoiceServicePhoneNumber",
    VoiceServicePhoneNumberExtension = "VoiceServicePhoneNumberExtension",
    VoiceShowInventoryEscalateTo = "VoiceShowInventoryEscalateTo",
    VoiceShowInventoryHasLLM = "VoiceShowInventoryHasLLM",
    VoiceShowInventoryMessage = "VoiceShowInventoryMessage",
    VoiceShowInventoryPhoneNumber = "VoiceShowInventoryPhoneNumber",
    VoiceShowInventoryTextMessage = "VoiceShowInventoryTextMessage",
    VoiceWelcomeMessage = "VoiceWelcomeMessage",
    WaitlistTagEmailList = "WaitlistTagEmailList",
    WalletPassURL = "WalletPassURL",
    WantsAccountPayBillContinueAutoPay = "WantsAccountPayBillContinueAutoPay",
    WantsBotInitiatedEscalationsLowConfidence = "WantsBotInitiatedEscalationsLowConfidence",
    WantsBotInitiatedEscalationsRateIncreases = "WantsBotInitiatedEscalationsRateIncreases",
    WantsBotInitiatedEscalationsSales = "WantsBotInitiatedEscalationsSales",
    WantsBotInitiatedEscalationsService = "WantsBotInitiatedEscalationsService",
    WantsBotInitiatedEscalationsWebIssues = "WantsBotInitiatedEscalationsWebIssues",
    WantsClearStoreVariables = "WantsClearStoreVariables",
    WantsCronReceiptsAbandonedCarts = "WantsCronReceiptsAbandonedCarts",
    WantsCronReceiptsMoveIn = "WantsCronReceiptsMoveIn",
    WantsCronReceiptsMoveOut = "WantsCronReceiptsMoveOut",
    WantsCronReceiptsPastDuePayments = "WantsCronReceiptsPastDuePayments",
    WantsCronReceiptsPaymentMethodExpired = "WantsCronReceiptsPaymentMethodExpired",
    WantsCronReceiptsPaymentSuccess = "WantsCronReceiptsPaymentSuccess",
    WantsCronReceiptsUpcomingPayment = "WantsCronReceiptsUpcomingPayment",
    WantsCronReceiptsUpdateContactInfo = "WantsCronReceiptsUpdateContactInfo",
    WantsCustomerInitiatedEscalations = "WantsCustomerInitiatedEscalations",
    WantsEmailReceipts = "WantsEmailReceipts",
    WantsLiveChatFirst = "WantsLiveChatFirst",
    WantsNewChatNotifications = "WantsNewChatNotifications",
    WantsOneMenuView = "WantsOneMenuView",
    WantsProfanityEscalation = "WantsProfanityEscalation",
    WantsSearchAnotherStore = "WantsSearchAnotherStore",
    Website = "Website",
    WebsiteProvider = "WebsiteProvider",
    WebsiteURL = "WebsiteURL",
    WelcomeLeadCollect = "WelcomeLeadCollect",
    WhatsAppAppId = "WhatsAppAppId",
    WhichMeasurementSystem = "WhichMeasurementSystem",
    whichTier = "whichTier",

}